import moment from "moment";
import {useContext, useEffect, useRef, useState} from "react";
import ReactQuill from "react-quill";
import {useFetcher, useNavigate, useParams, Link} from "react-router-dom";
import Swal from "sweetalert2";
import {ReactComponent as VoltarIcon} from "../../../assets/newImages/icons/arrowLeft.svg";
import {ReactComponent as Plus} from "../../../assets/newImages/icons/plus.svg";
import {ReactComponent as DescricaoIA} from "../../../assets/newImages/icons/descricao-ia.svg";
import { ReactComponent as TokensIa } from "../../../assets/newImages/icons/recursos-ia.svg";
import {Button} from "../../../components/Button/index";
import {FooterPaginas} from "../../../components/FooterPaginas/FooterPaginas";
import Form, {FormRef} from "../../../components/Form/index";
import ImgWithLoading from "../../../components/ImgWithLoading/ImgWithLoading";
import {Input} from "../../../components/Input/index";
import Modal from "../../../components/Modal/Modal";
import ModalSucesso from "../../../components/Modal/ModalSucesso/index";
import PopoverInfo from "../../../components/PopoverInfo/PopoverInfo";
import {Select} from "../../../components/Select/index";
import {ImageUploadProduto} from "../../../components/Upload/imageUploadProduto/ImageUploadProduto";
import SkeletonCadastroProduto from "../../../components/Skeletons/SkeletonCadastroProduto/SkeletonCadastroProduto";
import {SlidingBox} from "../../../components/SlidingBox/index";
import Tabs from "../../../components/Tabs/Tabs";
import {Textarea} from "../../../components/Textarea/index";
import {Toggle} from "../../../components/Toggle/Toggle";
import {useTheme} from "../../../contexts/Theme/ThemeContext";
import {TokensContext} from "../../../contexts/Tokens/TokensContext";
import {AuthContext} from "../../../contexts/Auth/AuthContext";
import {PERMISSOES} from "../../../services/Consts";
import {configuracoesApi} from "../../../hooks/configuracoesApi";
import {listasDePrecoApi} from "../../../hooks/listasDePreco";
import {produtoApi} from "../../../hooks/produtoApi";
import {produtosApi} from "../../../hooks/produtosApi";
import {currencyMask} from "../../../services/Masks";
import {unmaskToInt} from "../../../services/Unmasks";
import {ListaDePrecoBox} from "./cadastrosBox/listasDePreco/ListasDePreco";
import {MidiasBox} from "./midiasBox/midiasBox";
import {MediaVariationSelector} from "../../../components/MediaVariationSelector/MediaVariationSelector";
import "./styles";
import {FooterWrapper, ContainerDescricaoIa, ViewContainer} from "./styles";
import {VariacoesBoxV2} from "./variacoesBox/VariacoesBox";
import {useVariacoes} from "./hooks/useVariacoes";
import LockedIcon from "../../../components/LockedIcon/LockedIcon";
import { EmpresaApi } from "../../../hooks/empresaApi";
import { ModalTagsDestaque } from "../../../components/ModalTagsDestaque/ModalTagsDestaque";
import { tagsApi } from "../../../hooks/tagsApi";
import { caracteristicasApi } from "../../../hooks/caracteristicasApi";
import { TagValueInput } from "../../../components/TagValueInput/TagValueInput";
import { tiposVariacaoApi } from "../../../hooks/tiposVariacaoApi";
import { TagDestaque, TipoVariacao, NivelVariacao, VariacaoV2 } from "../../../types/Produto";

function Produto({permissoesPlano}) {
    const [id_produto, setID] = useState(useParams().id);
    const {theme} = useTheme();
    const { atualizarTokens, decrementarTokens, validarTokensSuficientes, tokensDisponiveis } = useContext(TokensContext);
    const { permissoesUsuario } = useContext(AuthContext);

    // Eixo A: se o usuário é customizado em Produtos (tem alguma pílula 100/101/102), respeita as ações;
    // senão (não-customizado) libera como hoje (regra 1). Reutiliza o "desabilita tudo" do ERP.
    const temPilulaProduto = [
        PERMISSOES.PRODUTOS_VISUALIZAR,
        PERMISSOES.PRODUTOS_CRIAR_EDITAR,
        PERMISSOES.PRODUTOS_EXCLUIR,
    ].some((id) => permissoesUsuario?.includes(id));
    const podeEditarProduto = !temPilulaProduto || !!permissoesUsuario?.includes(PERMISSOES.PRODUTOS_CRIAR_EDITAR);
    const podeExcluirProduto = !temPilulaProduto || !!permissoesUsuario?.includes(PERMISSOES.PRODUTOS_EXCLUIR);

    const [empresa, setEmpresa] = useState<Empresa | null>();

    const [tab, setTab] = useState(0);
    const [produto, setProduto] = useState<any>({
        id: id_produto,
        id_pasta: 0,
        id_empresa: 0,
        nome: "",
        referencia: "",
        descricao: "",
        peso: null,
        data_publicacao: new Date(),
        observacao_interna: "",
        multiplicador: 1,
        quantidade_minima: 1,
        quantidade_minima_soma: 0,
        solicitar_observacao: "0",
        fotos: [],
        variacoes: [],
        ativo: 1,
    });

    const ConfiguracoesApi = configuracoesApi();

    const [configIntegracaoConta, setConfigIntegracao] = useState({
        permitir_produtos: false,
        permitir_imagens: false,
        permitir_observacoes: false,
        integracao_bling: false,
        // Revendedor do dropshipping: categorias, tabelas e IA desativados
        dropshipping_satelite: false,
    });

    // Dropshipping: produto copiado da mãe fica travado mesmo depois que a chave é removida
    const [produtoCopiaDropshipping, setProdutoCopiaDropshipping] = useState(false);
    const config_integracao = produtoCopiaDropshipping
        ? {
            ...configIntegracaoConta,
            permitir_produtos: false,
            permitir_imagens: false,
            permitir_observacoes: false,
            dropshipping_satelite: true,
        }
        : configIntegracaoConta;

    const [duplicadoProcessado, setDuplicadoProcessado] = useState(false);
    let {duplicated} = useParams<{ duplicated: string }>();

    if (duplicated != "duplicado") {
        duplicated = "";
    }
    useEffect(() => {
        if (duplicated === "duplicado" && !duplicadoProcessado) {
            setProduto((prev) => ({
                ...prev,
                id: null,
                nome: prev.nome + " - Cópia",
                referencia: "",
                duplicado: true,
                fotos: prev.fotos.map((foto) => ({
                    ...foto,
                    id: '0',
                    id_produto: null,
                })),
                variacoes: prev.variacoes.map((v) => ({
                    ...v,
                    id: null,
                    id_produto: null,
                    precos: v.precos ? v.precos.map((p) => ({
                        ...p,
                        id: null,
                        id_variacao: null,
                    })) : [],
                })),
            }));
            setActiveTab('informacoes');
            setDuplicadoProcessado(true);
        }
    }, [duplicated, duplicadoProcessado]);

    useEffect(() => {
        const init = async () => {
            const res = await ConfiguracoesApi.verifica_config_integracoes();
            setConfigIntegracao({
                permitir_produtos: res.upload_produtos && podeEditarProduto,
                permitir_imagens: res.upload_imagens && podeEditarProduto,
                permitir_observacoes: res.upload_configurar_observacao && podeEditarProduto,
                integracao_bling: res.integracao_bling,
                dropshipping_satelite: !!res.dropshipping_satelite,
            });
        };
        init();
    }, [podeEditarProduto]);

    useEffect(() => {
        const fetchEmpresa = async () => {
            try {
                const empresaData = await EmpresaApi().get_empresa_usuario();
                setEmpresa(empresaData);
            } catch (e) {
                setEmpresa(null);
            }
        };
        fetchEmpresa();
    }, []);


    const ApiListasDePreco = listasDePrecoApi();
    const [listasDePreco, setListasDePreco] = useState<any>([]);
    const [temVariacao, setTemVariacao] = useState(false);
    const [temEstoque, setTemEstoque] = useState(false);
    const [temDestaque, setTemDestaque] = useState(false);
    const [tagsDestaque, setTagsDestaque] = useState<TagDestaque[]>([]);
    const [tagSelecionada, setTagSelecionada] = useState<string>("");
    const [modalTagsOpen, setModalTagsOpen] = useState(false);
    const [caracteristicas, setCaracteristicas] = useState<string[]>([]);
    const [sugestoesCaracteristicas, setSugestoesCaracteristicas] = useState<string[]>([]);
    const [temCaracteristica, setTemCaracteristica] = useState(false);
    const tiposVariacaoPadrao: TipoVariacao[] = [
        { id: -1, id_empresa: 0, nome: "Tamanho", padrao: true, ativo: 1, ordem: 0 },
        { id: -2, id_empresa: 0, nome: "Cor/banho", padrao: true, ativo: 1, ordem: 1 },
        { id: -3, id_empresa: 0, nome: "Gênero", padrao: true, ativo: 1, ordem: 2 },
    ];
    const [tiposVariacao, setTiposVariacao] = useState<TipoVariacao[]>(tiposVariacaoPadrao);
    const [sugestoesVariacao, setSugestoesVariacao] = useState<Record<string, string[]>>({});
    const [categorias, setCategorias] = useState<any>([]);
    const [needInit, setNeedInit] = useState(true);
    const [novaCategoria, setNovaCategoria] = useState(0);
    const [novaListaDePreco, setNovaListaDePreco] = useState(0);
    const [loading, setLoading] = useState(true);
    const [fotosBloqueadas, setFotosBloqueadas] = useState(false);

    const [variacoesBloqueadas, setVariacoesBloqueadas] = useState(false);
    const [produtosBloqueados, setProdutosBloqueados] = useState(false);

    const [mouseSobreImagem, setMouseSobreImagem] = useState(false);

    const formRef = useRef<FormRef | null>(null);
    const midiasBoxRef = useRef<{ triggerPhotoUpload: () => void }>(null);
    const imageUploadIARef = useRef<{ triggerFileInput: () => void }>(null);
    const categoriasTabRef = useRef<HTMLDivElement>(null);
    const [isValid, setIsValid] = useState(false);
    const [formValidIA, setFormValidIA] = useState(false);

    const navigate = useNavigate();

    const [textoBotao, setTextoBotao] = useState("Salvar");

    const [midiasBox, setMidiasBox] = useState(false);

    const [modalAtualizando, setModalAtualizando] = useState(false);
    const [mensagemModal, setMensagemModal] = useState("");
    const [stateModal, setStateModal] = useState("loading");

    const [auxAvancado, setAuxAvancado] = useState({
        data_publicacao: moment().format("YYYY-MM-DD HH:mm"),
        solicitar_observacao: "0",
        multiplicador: "1",
        quantidade_minima: "1",
        quantidade_minima_soma: 0,
        observacao_interna: "",
    });

    const [salvando, setSalvando] = useState(false);

    const [forceTab, setForceTab] = useState<{ tab: string; ts: number } | null>(null);
    const [closeCategoriasSignal, setCloseCategoriasSignal] = useState(0);
    const [modalListaDePreco, setModalListaDePreco] = useState(false);
    const [modalGerarDescricaoIa, setModalGerarDescricaoIa] = useState(false);
    const [modalResultadoIA, setModalResultadoIA] = useState(false);

    // Estados para os campos do modal de gerar descrição IA
    const carregarDadosCache = () => {
        try {
            const dadosCache = localStorage.getItem('conecta_ia_form_cache');
            if (dadosCache) {
                const dados = JSON.parse(dadosCache);
                return dados;
            }
        } catch (error) {
        }
        return {};
    };

    const [tomDeVoz, setTomDeVoz] = useState(() => {
        const tomSalvo = localStorage.getItem('conecta_tom_voz_persistente');
        return tomSalvo || "";
    });
    const [nomeProdutoIA, setNomeProdutoIA] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.nomeProdutoIA || "";
    });
    const [caracteristicasBeneficios, setCaracteristicasBeneficios] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.caracteristicasBeneficios || "";
    });
    const [instrucoesEspeciais, setInstrucoesEspeciais] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.instrucoesEspeciais || "";
    });
    const [quantidadePalavrasMin, setQuantidadePalavrasMin] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.quantidadePalavrasMin || "";
    });
    const [quantidadePalavrasMax, setQuantidadePalavrasMax] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.quantidadePalavrasMax || "";
    });
    const [imagemProdutoIA, setImagemProdutoIA] = useState(() => {
        const dadosCache = carregarDadosCache();
        return dadosCache.imagemProdutoIA || "";
    });
    const [imagemRemovidaManualmente, setImagemRemovidaManualmente] = useState(false);
    const [resultadoNomeIA, setResultadoNomeIA] = useState("");
    const [resultadoDescricaoIA, setResultadoDescricaoIA] = useState("");
    const [gerandoDescricaoIA, setGerandoDescricaoIA] = useState(false);
    const [tokensUtilizados, setTokensUtilizados] = useState(null);

    // Estados do fluxo "Melhorar foto com IA" (modais React, padrão do modal de descrição).
    const [modalMelhorarFotoIa, setModalMelhorarFotoIa] = useState(false);
    const [modalResultadoFotoIa, setModalResultadoFotoIa] = useState(false);
    const [melhorandoImagemIA, setMelhorandoImagemIA] = useState(false);
    const [resultadoImagemIA, setResultadoImagemIA] = useState("");
    const [tokensUsadosImagemIA, setTokensUsadosImagemIA] = useState<number | null>(null);
    const [fotoMelhorarIndex, setFotoMelhorarIndex] = useState<number | null>(null);

    const salvarDadosCache = (dados) => {
        try {
            const dadosCache = dados || {
                nomeProdutoIA,
                caracteristicasBeneficios,
                instrucoesEspeciais,
                quantidadePalavrasMin,
                quantidadePalavrasMax,
                imagemProdutoIA
            };
            localStorage.setItem('conecta_ia_form_cache', JSON.stringify(dadosCache));
        } catch (error) {
        }
    };

    const salvarTomDeVozPersistente = (tom) => {
        try {
            localStorage.setItem('conecta_tom_voz_persistente', tom);
        } catch (error) {
            
        }
    };

    const limparCacheFormulario = () => {
        try {
            localStorage.removeItem('conecta_ia_form_cache');
            setNomeProdutoIA("");
            setCaracteristicasBeneficios("");
            setInstrucoesEspeciais("");
            setQuantidadePalavrasMin("");
            setQuantidadePalavrasMax("");
            setImagemProdutoIA("");
        } catch (error) {
        }
    };

    const [variacaoUnica, setVariacaoUnica] = useState({
        id: "0",
        id_produto: produto.id,
        variacao: "",
        estoque:
            !loading && produto.variacoes.length
                ? produto.variacoes[0].estoque
                : null,
        ativo: 1,
        precos: [
            ...listasDePreco
                .filter((tabela) => Number(tabela.ativo))
                .map((tabela) => ({
                    id: "0",
                    id_variacao: "0",
                    id_tabela: tabela.id,
                    preco: "0",
                })),
        ],
    });

    const variacoesV2 = useVariacoes({
        listasDePreco,
        skuPai: produto.referencia,
        idProduto: produto.id,
        temEstoque,
    });

    const [activeTab, setActiveTab] = useState("informacoes");

    const [tabs, setTabs] = useState([
        {name: "Informações", value: "informacoes"},
        {name: "Mídias", value: "midias"},
    ]);

    function generateRandomString() {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const digits = "0123456789";

        for (let i = 0; i < 3; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * characters.length)
            );
        }

        for (let i = 0; i < 4; i++) {
            result += digits.charAt(Math.floor(Math.random() * digits.length));
        }

        return result;
    }

    const estoqueVazio = (estoque) =>
        estoque === null || estoque === undefined || String(estoque).trim() === "";

    const truncateText = (text) => {
        return text.length > 12 ? text.substring(0, 12) + "..." : text;
    };

    function novaVariacao() {
        if (variacoesBloqueadas) {
            Swal.fire({
                title: "Erro!",
                text: "Você atingiu o limite de variações cadastradas no plano atual. Para cadastrar mais variações, entre em contato com o suporte.",
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        }

        const nova_variacao = {
            id: "0",
            id_produto: produto.id,
            variacao: "",
            ativo: "1",
            estoque: "0",
            precos: [
                ...listasDePreco.map((tabela) => {
                    return {
                        id: "0",
                        id_variacao: "0",
                        id_tabela: tabela.id,
                        preco: "0",
                    };
                }),
            ],
        };

        setProduto({
            ...produto,
            variacoes: [...produto.variacoes, nova_variacao],
        });
    }

    const handleExcluirProduto = () => {
        Swal.fire({
            title: "Tem certeza que deseja inativar este produto?",
            icon: "warning",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Inativar",
            showCancelButton: true,
            showCloseButton: true,
            customClass: {
                confirmButton: "btn-confirm",
                cancelButton: "btn-cancel",
                icon: "custom-swal-icon",
                title: "custom-swal-title",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Tem certeza?",
                    html: "Ao inativar, seu produto não ficará mais <br />disponível nos catálogos, mas poderá reativar posteriormente, em <b>Meus Produtos<b/>.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Inativar (5)",
                    cancelButtonText: "Cancelar",
                    customClass: {
                        confirmButton: "btn-confirm2",
                        popup: "custom-swal-popup",
                        icon: "custom-swal-icon",
                        title: "custom-swal-title",
                    },
                    didOpen: () => {
                        const confirmButton = Swal.getConfirmButton();
                        if (confirmButton) {
                            confirmButton.disabled = true;
                            let secondsLeft = 5;
                            const timerInterval = setInterval(() => {
                                secondsLeft--;
                                confirmButton.innerText = `Inativar (${secondsLeft})`;
                                if (secondsLeft <= 0) {
                                    confirmButton.disabled = false;
                                    confirmButton.innerText = "Inativar";
                                }
                            }, 1000);
                        }
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        inativaProduto()
                            .then(() => {
                                Swal.fire({
                                    title: "Sucesso!",
                                    text: "Produto inativado com sucesso",
                                    icon: "success",
                                    timer: 1250,
                                    showConfirmButton: false,
                                });

                                navigate("/painel/produtos");
                                setSalvando(false);
                            })
                            .catch(() => {
                                Swal.fire({
                                    title: "Erro!",
                                    text: "Erro ao inativar o produto",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                });
                                setSalvando(false);
                            });
                    }
                });
            }
        });
    };

    function adicionaFoto(newImage: {
        base64: string;
        imagem: string;
        size: number;
    }) {
        const fotos = [
            ...produto.fotos,
            {
                base64: newImage.base64,
                id: "0",
                id_produto: produto.id,
                imagem: newImage.imagem,
                ordem: produto.fotos.length,
                tamanho: newImage.size,
                tipo: 1,
            },
        ];
        setProduto({
            ...produto,
            fotos: [...fotos],
        });
    }

    function adicionaVideo(url_video) {
        let video = {
            id: "0",
            id_produto: produto.id,
            imagem: url_video,
            ordem: produto.fotos.length,
            tipo: 2,
            miniaturaVideo: "",
        };
        // Pega Thumbnail do vídeo do YouTube
        video.miniaturaVideo = obterMiniaturaVideoYouTube(video.imagem);
        setProduto({
            ...produto,
            fotos: [...produto.fotos, video],
        });
    }

    function obterMiniaturaVideoYouTube(link) {
        let videoId = "";

        const patterns = [
            // YouTube normal: https://www.youtube.com/watch?v=VIDEO_ID
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
            // YouTube mobile/short URL: https://youtu.be/VIDEO_ID
            /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/,
            // YouTube Shorts: https://www.youtube.com/shorts/VIDEO_ID
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/,
            // YouTube embed: https://www.youtube.com/embed/VIDEO_ID
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)/
        ];
        
        for (const pattern of patterns) {
            const match = link.match(pattern);
            if (match && match[1]) {
                videoId = match[1];
                break;
            }
        }
        
        if (!videoId) {
            let miniaturaVideo = link.split("/")[3];
            miniaturaVideo = miniaturaVideo.split("=");
            videoId = miniaturaVideo.length === 2 ? miniaturaVideo[1] : miniaturaVideo[0];
        }
        
        return `https://img.youtube.com/vi/${videoId}/0.jpg`;
    }

    function replicaEstoques(estoque) {
        const variacoes = [...produto.variacoes];
        variacoes.forEach((variacao) => {
            variacao.estoque = estoque;
        });
        setProduto({
            ...produto,
            variacoes: [...variacoes],
        });
    }

    function replicaNomesVariacoes(nome) {
        const variacoes = [...produto.variacoes];
        variacoes.forEach((variacao) => {
            variacao.variacao = nome;
        });
        setProduto({
            ...produto,
            variacoes: [...variacoes],
        });
    }

    function replicaPrecoTabela(preco, index) {
        const variacoes = [...produto.variacoes];
        variacoes.forEach((variacao) => {
            if (variacao.precos && variacao.precos[index]) {
                variacao.precos[index].preco = preco;
            }
        });
        setProduto({
            ...produto,
            variacoes: [...variacoes],
        });
    }

    async function salvarProduto() {
        if (produto.id_pasta == 0) {
            Swal.fire({
                title: "Erro!",
                text: "Selecione uma categoria",
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (produto.fotos.length == 0) {
            Swal.fire({
                title: "Erro!",
                text: "Adicione uma imagem ao produto",
                icon: "error",
                confirmButtonText: "Ok",
            });
            setActiveTab("midias");
            return;
        }

        // Validação de peso alto (>1kg) em cadastro novo
        if (id_produto === "0" && produto.peso && Number(produto.peso) > 1000) {
            const pesoEmKg = (Number(produto.peso) / 1000).toFixed(3).replace('.', ',');
            const confirmacao = await Swal.fire({
                icon: "warning",
                title: "Talvez tenha algo errado",
                html: `Seu produto realmente pesa <strong>${pesoEmKg} kg</strong>?`,
                showCancelButton: true,
                confirmButtonText: "Sim, está correto",
                cancelButtonText: "Não, vou corrigir",
            });

            if (!confirmacao.isConfirmed) {
                return;
            }
        }

        if (produto.ativo == 0) {
            let response = await Swal.fire({
                icon: "question",
                title: "Deseja reativar o produto?",
                showCancelButton: true,
                confirmButtonText: "Reativar",
                cancelButtonText: "Cancelar",
            });
            if (!response.isConfirmed) {
                return;
            }
        }

        // Validações de variação (toggle ON)
        if (temVariacao) {
            // Bloquear quando nenhum nível de variação foi configurado
            if (variacoesV2.niveisVariacao.length === 0) {
                Swal.fire({
                    title: "Erro!",
                    text: "Adicione ao menos uma variação ao produto.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                return;
            }

            // Validação: níveis de variação sem valores preenchidos
            const nivelSemValores = variacoesV2.niveisVariacao.find(n => n.valores.length === 0);
            if (nivelSemValores) {
                Swal.fire({
                    title: "Erro!",
                    text: `Preencha os valores da variação "${nivelSemValores.tipo.nome}"`,
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                return;
            }

            // Bloquear quando não há nenhuma variação ativa cadastrada
            const variacoesAtivas = variacoesV2.variacoes.filter(v => Number(v.ativo) === 1);
            if (variacoesAtivas.length === 0) {
                Swal.fire({
                    title: "Erro!",
                    text: "Cadastre ao menos uma variação ativa para o produto.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                return;
            }

            // Validação: SKU duplicado entre variações
            const skusAtivos = variacoesAtivas
                .map(v => (v.sku || "").trim().toLowerCase())
                .filter(s => s);
            const skusUnicos = new Set(skusAtivos);
            if (skusUnicos.size < skusAtivos.length) {
                Swal.fire({
                    title: "Erro!",
                    text: "Já existe uma variação com esse SKU, por favor, escolha outro SKU.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                return;
            }
        }

        setSalvando(true);

        // Clone the produto object
        const produtoClone = {...produto};

        // Remove the description if it's null
        produtoClone.descricao = produtoClone.descricao || "";
        produtoClone.ativo = 1;

        // Format photos and adjust their properties
        produtoClone.fotos.forEach((foto, index) => {
            foto.ordem = index;
            if (foto.miniaturaVideo) {
                foto.imagem_externa = foto.miniaturaVideo;
            }
        });

        // Handle variations
        if (!temVariacao) {
            produtoClone.variacoes = produtoClone.variacoes.filter(
                (variacao) => Number(variacao.id) != 0
            );
            produtoClone.variacoes.forEach((variacao) => {
                variacao.ativo = 0;
            });
            if (!temEstoque) {
                delete variacaoUnica.estoque;
            } else if (estoqueVazio(variacaoUnica.estoque)) {
                // Ligou o controle sem informar estoque: começa em 0, não null.
                variacaoUnica.estoque = "0";
            }
            // Copia o id da variacao existente
            variacaoUnica.id = produto.id != "0" && produtoClone.variacoes.length > 0 ? produtoClone.variacoes[0].id : "0";

            // Atribui os outros campos
            produtoClone.variacoes[0] = variacaoUnica;
        } else {
            // Com variações ativas, o peso é definido por variação;
            // zera o peso do produto principal para não ser considerado.
            produtoClone.peso = null;

            // Se estamos usando V2 com niveis, usar as variacoes do hook
            if (variacoesV2.niveisVariacao.length > 0) {
                const nivel0 = variacoesV2.niveisVariacao.find(n => n.ordem === 0);
                const nivel1 = variacoesV2.niveisVariacao.find(n => n.ordem === 1);
                const idTipoVariacao = nivel0?.tipo?.id || null;
                const idTipoSubvariacao = nivel1?.tipo?.id || null;

                const isDuplicado = !produtoClone.id || produtoClone.id === "0" || produtoClone.duplicado;
                produtoClone.variacoes = variacoesV2.variacoes.map((v, index) => ({
                    id: isDuplicado ? "0" : v.id,
                    id_produto: isDuplicado ? "0" : v.id_produto,
                    variacao: v.valor_principal,
                    subvariacao: v.valor_secundario || null,
                    id_variacao: idTipoVariacao,
                    id_subvariacao: idTipoSubvariacao,
                    // Posição na grade — define a ordem de exibição no catálogo.
                    ordem: index,
                    sku: v.sku,
                    peso: v.peso,
                    estoque: !temEstoque ? undefined : (estoqueVazio(v.estoque) ? "0" : v.estoque),
                    ativo: v.ativo,
                    precos: isDuplicado ? v.precos.map(p => ({ ...p, id: "0", id_variacao: "0" })) : v.precos,
                }));
                // Salvar também no nível do produto (usado pelo catálogo nos JOINs)
                produtoClone.id_variacao = idTipoVariacao;
                produtoClone.id_subvariacao = idTipoSubvariacao;
                delete produtoClone.niveis_variacao;
            } else {
                produtoClone.variacoes.forEach((variacao) => {
                    if (!temEstoque) {
                        delete variacao.estoque;
                    } else if (estoqueVazio(variacao.estoque)) {
                        variacao.estoque = "0";
                    }
                });
            }
        }

        // Format the publication date
        produtoClone.data_publicacao = moment(produtoClone.data_publicacao).format(
            "YYYY-MM-DD HH:mm"
        );

        // Remove unnecessary property
        delete produtoClone.variacoes_precos;

        delete produtoClone.catalogos;

        produtoClone.quantidade_minima =
            parseInt(auxAvancado.quantidade_minima) || 1;
        produtoClone.quantidade_minima_soma = auxAvancado.quantidade_minima_soma;
        produtoClone.multiplicador = parseInt(auxAvancado.multiplicador) || 1;

        // Adicionar tag de destaque
        if (tagSelecionada) {
            produtoClone.id_tag_destaque = parseInt(tagSelecionada);
        } else {
            produtoClone.id_tag_destaque = null;
        }
        produtoClone.tag_destaque_ativo = temDestaque ? 1 : 0;

        // Adicionar características (toggle desligado = limpa)
        produtoClone.caracteristicas = temCaracteristica ? caracteristicas : [];

        return saveProductToApi(produtoClone)
            .then(() => {
                Swal.fire({
                    title: "Sucesso!",
                    text: "Produto salvo com sucesso",
                    icon: "success",
                    timer: 1250,
                    showConfirmButton: false,
                });

                // Limpar cache dos campos de IA (manter tom de voz)
                try {
                    localStorage.removeItem('conecta_ia_form_cache');
                } catch (error) {
                    // Erro silencioso ao limpar cache
                }

                navigate("/painel/produtos");
                setSalvando(false);
            })
            .catch((err) => {
                console.log(err);
                if (err.response.data.error === "REFERENCIA_JA_EXISTE") {
                    Swal.fire({
                        title: "Erro!",
                        text: "Já existe um produto com esse SKU, por favor, escolha outro SKU.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                } else if (err.response.data.error === "LIMITE_PRODUTOS_EXCEDIDO") {
                    Swal.fire({
                        title: "Erro!",
                        text: "Você atingiu o limite de produtos cadastrados no plano atual. Para cadastrar mais produtos, entre em contato com o suporte.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                } else {
                    Swal.fire({
                        title: "Erro!",
                        text: "Erro ao salvar produto",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                }
                setSalvando(false);
            });
    }

    function saveProductToApi(produtoClone) {
        // Return the promise from the API call
        return produtoApi().produtoCriar(produtoClone);
    }

    function inativaProduto() {
        // Return the promise from the API call
        return produtoApi().produtoInativar(produto.id);
    }

    function deletaVariacao(index: number) {
        produto.variacoes[index].ativo = "0";

        //se todas as variacoes estiverem inativas seta temVariacao para false

        let temVariacao = false;

        produto.variacoes.forEach((variacao) => {
            if (Number(variacao.ativo) == 1) {
                temVariacao = true;
            }
        });

        setTemVariacao(temVariacao);

        setProduto({
            ...produto,
            variacoes: [...produto.variacoes],
        });
    }

    function Avancar() {
        if (activeTab == "avancado") {
            const quantidade =
                parseInt(auxAvancado.quantidade_minima.toString()) || 1;
            const multiplicador = parseInt(auxAvancado.multiplicador.toString()) || 1;

            setActiveTab("informacoes");
            setProduto({
                ...produto,
                quantidade_minima: quantidade,
                quantidade_minima_soma: auxAvancado.quantidade_minima_soma,
                data_publicacao: auxAvancado.data_publicacao,
                multiplicador: multiplicador,
                solicitar_observacao: auxAvancado.solicitar_observacao,
                observacao_interna: auxAvancado.observacao_interna,
            });

            tabs.pop();
            setTabs([...tabs]);
        } else if (activeTab == "midias") {
            if (!isValid) {
                setActiveTab("informacoes");
                return;
            }
            salvarProduto();
        } else if (activeTab == "informacoes") {
            formRef.current && formRef.current.submitForm();
            if (!isValid) return;
            setActiveTab("midias");
        }
    }

    function Voltar() {
        if (activeTab == "avancado") {
            setActiveTab("informacoes");
            const quantidade = parseInt(produto.quantidade_minima?.toString()) || 1;
            const multiplicador = parseInt(auxAvancado.multiplicador.toString()) || 1;

            setAuxAvancado({
                quantidade_minima: quantidade.toString(),
                quantidade_minima_soma: Number(produto.quantidade_minima_soma) === 1 ? 1 : 0,
                data_publicacao: produto.data_publicacao,
                multiplicador: multiplicador.toString(),
                solicitar_observacao: produto.solicitar_observacao,
                observacao_interna: auxAvancado.observacao_interna,
            });

            //remove o ultimo indice de tabs
            tabs.pop();
            setTabs([...tabs]);
        } else if (activeTab == "midias") {
            setActiveTab("informacoes");
        } else if (activeTab == "informacoes") {
            //todo
        }
    }

    function removeImagem(index) {
        const fotos = [...produto.fotos];
        fotos.splice(index, 1);
        setProduto({
            ...produto,
            fotos: [...fotos],
        });
    }

    function moveImagemEsquerda(index) {
        const fotos = [...produto.fotos];
        [fotos[index - 1], fotos[index]] = [fotos[index], fotos[index - 1]];
        setProduto({
            ...produto,
            fotos: [...fotos],
        });
    }

    function moveImagemDireita(index) {
        const fotos = [...produto.fotos];
        [fotos[index], fotos[index + 1]] = [fotos[index + 1], fotos[index]];
        setProduto({
            ...produto,
            fotos: [...fotos],
        });
    }

    // Estimativa só para portão/UX. O débito real vem do backend (usageMetadata).
    const ESTIMATIVA_TOKENS_IMAGEM_IA = 2500;

    // Substitui a foto pelo resultado da IA. Setar `base64` força o re-upload no save
    // (criar.php decide o upload por array_key_exists('base64', $foto)).
    function baixarImagemMelhorada(dataUri: string) {
        const a = document.createElement("a");
        a.href = dataUri;
        a.download = `imagem-melhorada-${Date.now()}.jpg`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function usarImagemMelhorada(index: number, dataUri: string) {
        const fotos = [...produto.fotos];
        // Limpa as URLs antigas para: (a) o preview da galeria mostrar já o base64 novo,
        // (b) o save re-enviar ao S3 (criar.php sobrescreve imagem_externa/_2 no upload).
        fotos[index] = {
            ...fotos[index],
            base64: dataUri,
            imagem_externa: undefined,
            imagem_externa_2: undefined,
        };
        setProduto({ ...produto, fotos: [...fotos] });
    }

    // Abre o modal de confirmação para melhorar a foto do índice informado.
    function abrirMelhorarFotoIA(index: number) {
        if (melhorandoImagemIA) return;
        const foto = produto.fotos[index];
        if (!foto || foto.tipo != 1) return;
        setFotoMelhorarIndex(index);
        setResultadoImagemIA("");
        setTokensUsadosImagemIA(null);
        setModalMelhorarFotoIa(true);
    }

    // Gera a imagem melhorada (chamado pelo botão "Melhorar foto" do modal).
    async function handleMelhorarFotoIA() {
        if (melhorandoImagemIA || fotoMelhorarIndex === null) return;
        const foto = produto.fotos[fotoMelhorarIndex];
        if (!foto) return;

        // Fonte da imagem: base64 (foto nova) ou URL do CDN (foto já salva).
        let imagemSrc: string = foto.base64 || foto.imagem_externa || foto.imagem_externa_2;
        if (!imagemSrc) {
            Swal.fire({ title: "Erro", text: "Não foi possível localizar a imagem.", icon: "error", confirmButtonText: "Ok" });
            return;
        }
        if (imagemSrc.includes("{size}")) imagemSrc = imagemSrc.replace("{size}", "900");

        if ((tokensDisponiveis ?? 0) < ESTIMATIVA_TOKENS_IMAGEM_IA) {
            Swal.fire({ title: "Tokens insuficientes", text: "Você não tem tokens suficientes para melhorar esta imagem.", icon: "warning", confirmButtonText: "Ok" });
            return;
        }

        setMelhorandoImagemIA(true);
        try {
            const data = await produtoApi().melhorarImagemIA(imagemSrc);

            if (!data?.success || !data?.imagem_base64) {
                Swal.fire({ title: "Não foi possível melhorar a imagem", text: data?.error || "Tente novamente em instantes.", icon: "error", confirmButtonText: "Ok" });
                return;
            }

            // Débito já ocorreu no backend; sincroniza saldo e abre o resultado.
            atualizarTokens();
            setResultadoImagemIA(data.imagem_base64);
            setTokensUsadosImagemIA(data.tokens_usados ?? null);
            setModalMelhorarFotoIa(false);
            setModalResultadoFotoIa(true);
        } catch (err: any) {
            Swal.fire({ title: "Erro", text: err?.response?.data?.error || "Falha ao comunicar com a IA.", icon: "error", confirmButtonText: "Ok" });
        } finally {
            setMelhorandoImagemIA(false);
        }
    }

    // Aplica a imagem melhorada no lugar da original e fecha o resultado.
    function aplicarImagemMelhorada() {
        if (fotoMelhorarIndex === null || !resultadoImagemIA) return;
        usarImagemMelhorada(fotoMelhorarIndex, resultadoImagemIA);
        setModalResultadoFotoIa(false);
    }

    function Avancado() {
        const newTabs = [...tabs];
        if (newTabs.length === 2) {
            newTabs.push({name: "Avançado", value: "avancado"});
            setActiveTab("avancado");
        }
        setTabs(newTabs);
    }

    useEffect(() => {
        if (activeTab == "avancado") {
            setTextoBotao("Salvar");
        } else if (activeTab == "midias") {
            setTextoBotao("Salvar e criar o produto");
        } else if (activeTab == "informacoes") {
            setTextoBotao(`Salvar`);
        }
    }, [activeTab]);

    // useEffect para salvar dados do formulário de IA no cache
    useEffect(() => {
        const dadosCache = {
            nomeProdutoIA,
            caracteristicasBeneficios,
            instrucoesEspeciais,
            quantidadePalavrasMin,
            quantidadePalavrasMax,
            imagemProdutoIA
        };
        salvarDadosCache(dadosCache);
    }, [nomeProdutoIA, caracteristicasBeneficios, instrucoesEspeciais, quantidadePalavrasMin, quantidadePalavrasMax, imagemProdutoIA]);

    // useEffect para salvar tom de voz persistente
    useEffect(() => {
        if (tomDeVoz) {
            salvarTomDeVozPersistente(tomDeVoz);
        }
    }, [tomDeVoz]);

    // useEffect para limpar campos ao desmontar componente (manter tom de voz)
    useEffect(() => {
        return () => {
            // Cleanup: limpar cache dos campos ao sair da tela
            try {
                localStorage.removeItem('conecta_ia_form_cache');
            } catch (error) {
                console.error('Erro ao limpar cache na saída:', error);
            }
        };
    }, []);

    const fetchCategorias = async () => {
        const result_categorias = await produtosApi().getCategorias();

        const pais = result_categorias.filter((c) => Number(c.id_pasta_pai) === 0).sort((a, b) => a.descricao.localeCompare(b.descricao));

        const options: { name: string; value: string }[] = [];

        for (const pai of pais) {
            options.push({ name: pai.descricao, value: pai.id });
            const subs = result_categorias.filter((c) => String(c.id_pasta_pai) === String(pai.id)).sort((a, b) => a.descricao.localeCompare(b.descricao));
            for (const sub of subs) {
                options.push({ name: `${pai.descricao} / ${sub.descricao}`, value: sub.id });
            }
        }

        setCategorias(options);
    };

    useEffect(() => {
        const init = async () => {
            const id = Number(id_produto);
            let response = produto;
            const ListasResult = await ApiListasDePreco.getListas(true);
            await fetchCategorias();

            // Carregar tags de destaque
            try {
                const tagsResult = await tagsApi().getTags();
                setTagsDestaque(tagsResult);
            } catch (error) {
                console.error("Erro ao carregar tags:", error);
            }

            // Carregar sugestões de características (autocomplete)
            try {
                const caracteristicasResult = await caracteristicasApi().getCaracteristicas();
                setSugestoesCaracteristicas(caracteristicasResult.map((c) => c.nome));
            } catch (error) {
                console.error("Erro ao carregar características:", error);
            }

            // Carregar tipos de variação (mantém padrão se API falhar)
            let tiposCarregados = tiposVariacaoPadrao;
            try {
                const tiposResult = await tiposVariacaoApi().getTipos();
                if (tiposResult && tiposResult.length > 0) {
                    tiposCarregados = tiposResult;
                    setTiposVariacao(tiposResult);
                }
            } catch (error) {
                // Endpoint ainda não implementado no backend, usa padrões hardcoded
            }

            // Carregar sugestões de valores de variação sem bloquear a página.
            tiposVariacaoApi()
                .getSugestoes()
                .then((sugestoes) => {
                    if (sugestoes) setSugestoesVariacao(sugestoes);
                })
                .catch(() => {
                    // Sem sugestões disponíveis
                });

            if (id_produto != "0") {
                response = await produtoApi().getProduto(id);
            } else {
                response.variacoes = [];
            }

            setListasDePreco(ListasResult);

            const variacoesAtivas = response.variacoes.filter((v: any) => Number(v.ativo) === 1);
            if (
                (variacoesAtivas.length > 1 && loading) ||
                (variacoesAtivas.length == 1 && variacoesAtivas[0].variacao != "")
            ) {
                setTemVariacao(true);
            }

            let variacoes_id_0 = produto.variacoes.filter(
                (variacao) => Number(variacao.id) == 0
            );

            response.variacoes.push(...variacoes_id_0);

            if (response.variacoes.length == 0) {
                response.variacoes.push(variacaoUnica);
            }

            if (!response.variacoes_precos) {
                response.variacoes_precos = [];
            }

            response.variacoes.forEach((variacao) => {
                variacao.precos = [];

                if (variacao.estoque != null) setTemEstoque(true);

                ListasResult.forEach((tabela) => {
                    const tabela_preco = {
                        id: "0",
                        id_variacao: variacao.id,
                        id_tabela: tabela.id,
                        preco: "0",
                    };

                    const preco_encontrado =
                        response.variacoes_precos
                            .map((preco) => {
                                if (
                                    Number(preco.id_variacao) === Number(variacao.id) &&
                                    Number(preco.id_tabela) === Number(tabela_preco.id_tabela)
                                ) {
                                    return preco;
                                }
                            })
                            .filter(Boolean)[0] || {};

                    if (Object.keys(preco_encontrado).length) {
                        tabela_preco.id = preco_encontrado.id;
                        tabela_preco.preco = preco_encontrado.preco;
                    } else {
                        tabela_preco.preco = "0";
                    }

                    variacao.precos.push(tabela_preco);
                });
            });
            if (
                ListasResult.length > 0 &&
                response.variacoes.length > 0 &&
                loading &&
                response.id != "0"
            ) {
                const variacaoUnica = {
                    id: "0",
                    id_produto: produto.id,
                    variacao: "",
                    ativo: 1,
                    estoque: response.id != "0" ? response.variacoes[0].estoque : "0",
                    precos: [
                        ...ListasResult.filter((tabela) => Number(tabela.ativo)).map(
                            (tabela) => ({
                                id: "0",
                                id_variacao: "0",
                                id_tabela: tabela.id,
                                preco:
                                    response.id != "0"
                                        ? response.variacoes[0].precos
                                            .filter(
                                                (preco) =>
                                                    Number(preco.id_tabela) === Number(tabela.id)
                                            )
                                            .reduce((a, preco) => preco.preco, "0")
                                        : "0",
                            })
                        ),
                    ],
                };

                setVariacaoUnica(variacaoUnica);
            }

            if (!loading) {
                //adiciona apenas as novas response.variacoes.precos que nao existem nos produto.variacoes

                response.variacoes.forEach((variacao, index) => {
                    if (
                        produto &&
                        produto.variacoes &&
                        produto.variacoes[index] &&
                        produto.variacoes[index].precos &&
                        variacao &&
                        variacao.precos &&
                        produto.variacoes[index].precos.length !== variacao.precos.length
                    ) {
                        variacao.precos.forEach((preco, index_preco) => {
                            if (produto.variacoes[index].precos[index_preco] === undefined) {
                                produto.variacoes[index].precos.push(preco);
                            }
                        });
                    }

                    if (variacaoUnica.precos.length != variacao.precos.length) {
                        variacao.precos.forEach((preco, index_preco) => {
                            if (variacaoUnica.precos[index_preco] == undefined) {
                                variacaoUnica.precos.push(preco);
                            }
                        });
                    }
                });

                setProduto(produto);
            } else {
                setProduto(response);
            }

            setAuxAvancado({
                data_publicacao: response.data_publicacao,
                solicitar_observacao: response.solicitar_observacao,
                multiplicador: response.multiplicador?.toString() || "1",
                quantidade_minima: response.quantidade_minima?.toString() || "1",
                quantidade_minima_soma: Number(response.quantidade_minima_soma) === 1 ? 1 : 0,
                observacao_interna: response.observacao_interna,
            });

            setProdutoCopiaDropshipping(!!response.dropshipping_copia);

            // Setar tag de destaque se existir
            if (response.id_tag_destaque) {
                setTagSelecionada(response.id_tag_destaque.toString());
                setTemDestaque(response.tag_destaque_ativo == 1);
            }

            // Setar características do produto se existirem
            if (response.caracteristicas) {
                setCaracteristicas(response.caracteristicas.map((c: any) => c.nome));
                setTemCaracteristica(response.caracteristicas.length > 0);
            }

            // Hidratar variações V2 a partir da resposta da API
            // Ler o tipo de variação do produto (campos id_variacao e id_subvariacao da tabela produtos)
            const idVariacao = response.id_variacao ? Number(response.id_variacao) : null;
            const idSubvariacao = response.id_subvariacao ? Number(response.id_subvariacao) : null;
            if (idVariacao) {
                const niveisHidratados: NivelVariacao[] = [];

                const tipoPrincipal = tiposCarregados.find(t => Number(t.id) === idVariacao)
                    || { id: idVariacao, id_empresa: 0, nome: "Não definida", padrao: true, ativo: 0, ordem: 99 };
                niveisHidratados.push({
                    tipo: tipoPrincipal,
                    valores: [],
                    ordem: 0,
                });

                if (idSubvariacao) {
                    const tipoSecundario = tiposCarregados.find(t => Number(t.id) === idSubvariacao)
                        || { id: idSubvariacao, id_empresa: 0, nome: "Não definida", padrao: true, ativo: 0, ordem: 99 };
                    if (tipoSecundario) {
                        niveisHidratados.push({
                            tipo: tipoSecundario,
                            valores: [],
                            ordem: 1,
                        });
                    }
                }

                // Extrair valores únicos das variações existentes
                const valoresPrincipal = new Set<string>();
                const valoresSecundario = new Set<string>();
                response.variacoes?.forEach((v: any) => {
                    if (v.variacao) valoresPrincipal.add(v.variacao);
                    if (v.subvariacao) valoresSecundario.add(v.subvariacao);
                });

                if (niveisHidratados[0]) niveisHidratados[0].valores = Array.from(valoresPrincipal);
                if (niveisHidratados[1]) niveisHidratados[1].valores = Array.from(valoresSecundario);

                variacoesV2.setNiveisVariacao(niveisHidratados);

                // Hidratar as variações V2 existentes (filtrar variacaoUnica vazia)
                const variacoesReais = response.variacoes.filter((v: any) => v.variacao && v.variacao !== "");
                if (variacoesReais.length > 0) {
                    const skuBase = response.referencia || "";

                    // SKUs já usados pra não colidir ao numerar os vazios.
                    const skusUsados = new Set<string>(
                        variacoesReais.map((v: any) => (v.sku || "").trim()).filter(Boolean)
                    );
                    let proxN = 1;
                    const proximoSkuLivre = () => {
                        while (skusUsados.has(`${skuBase}-${proxN}`)) proxN++;
                        const novo = `${skuBase}-${proxN}`;
                        skusUsados.add(novo);
                        proxN++;
                        return novo;
                    };

                    const varV2: VariacaoV2[] = variacoesReais.map((v: any) => {
                        const valPrincipal = v.variacao || "";
                        const valSecundario = v.subvariacao || undefined;

                        const display = valSecundario
                            ? `${valPrincipal} | ${valSecundario}`
                            : valPrincipal;
                        return {
                            id: v.id,
                            id_produto: v.id_produto || response.id,
                            variacao: display,
                            valor_principal: valPrincipal,
                            valor_secundario: valSecundario,
                            ordem: v.ordem ?? null,
                            sku: (v.sku || "").trim() || proximoSkuLivre(),
                            estoque: v.estoque,
                            peso: v.peso ?? null,
                            ativo: v.ativo,
                            precos: v.precos || [],
                        };
                    });

                    // Deduplicar: manter apenas 1 variação por combinação principal+secundário
                    const seen = new Map<string, VariacaoV2>();
                    for (const v of varV2) {
                        const key = `${v.valor_principal.toLowerCase().trim()}|${(v.valor_secundario || "").toLowerCase().trim()}`;
                        const existing = seen.get(key);
                        if (!existing || (Number(v.ativo) === 1 && Number(existing.ativo) !== 1)) {
                            seen.set(key, v);
                        }
                    }

                    // Ordena pela ordem salva (definida pelo usuário na grade).
                    // Fallback pro sufixo do SKU ({base}-{N}) em produtos antigos
                    // sem 'ordem'. Mantém a grade alinhada com o campo de valores.
                    const sufixoNum = (sku: string) => {
                        const m = (sku || "").match(/-(\d+)$/);
                        return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER;
                    };
                    const ordenadas = Array.from(seen.values()).sort((a, b) => {
                        const oa = a.ordem;
                        const ob = b.ordem;
                        if (oa != null && ob != null && oa !== ob) return oa - ob;
                        if (oa != null && ob == null) return -1;
                        if (oa == null && ob != null) return 1;
                        return sufixoNum(a.sku) - sufixoNum(b.sku);
                    });

                    variacoesV2.setVariacoes(ordenadas);
                }
            } else if (loading && response.variacoes && response.variacoes.length >= 1 &&
                // Verificar se tem pelo menos 1 variação com nome preenchido (não é só a "UN" vazia)
                response.variacoes.some((v: any) => v.variacao && v.variacao !== "")
            ) {
                // Retrocompatibilidade: produto legado sem id_variacao
                // Setar tipo "Não definida" (id=4) como variação principal
                const tipoNaoDefinida: TipoVariacao = { id: 4, id_empresa: 0, nome: "Não definida", padrao: true, ativo: 0, ordem: 99 };

                const valoresUnicos = new Set<string>();
                response.variacoes.forEach((v: any) => {
                    if (v.variacao && v.variacao !== "") valoresUnicos.add(v.variacao);
                });

                const niveisHidratados: NivelVariacao[] = [{
                    tipo: tipoNaoDefinida,
                    valores: Array.from(valoresUnicos),
                    ordem: 0,
                }];

                variacoesV2.setNiveisVariacao(niveisHidratados);

                // Converter variações planas para formato V2
                const skuBase2 = response.referencia || "";

                // Mesma lógica do bloco acima: não recicla SKU já usado.
                const skusUsados2 = new Set<string>(
                    response.variacoes.map((v: any) => (v.sku || "").trim()).filter(Boolean)
                );
                let proxN2 = 1;
                const proximoSkuLivre2 = () => {
                    while (skusUsados2.has(`${skuBase2}-${proxN2}`)) proxN2++;
                    const novo = `${skuBase2}-${proxN2}`;
                    skusUsados2.add(novo);
                    proxN2++;
                    return novo;
                };

                const varV2: VariacaoV2[] = response.variacoes.map((v: any) => ({
                    id: v.id,
                    id_produto: v.id_produto || response.id,
                    variacao: v.variacao || "",
                    valor_principal: v.variacao || "",
                    valor_secundario: v.subvariacao || undefined,
                    ordem: v.ordem ?? null,
                    sku: (v.sku || "").trim() || proximoSkuLivre2(),
                    estoque: v.estoque,
                    peso: v.peso ?? response.peso ?? null,
                    ativo: v.ativo,
                    precos: v.precos || [],
                }));

                // Ordena pela ordem salva (definida pelo usuário na grade). Para
                // produtos antigos sem 'ordem', faz fallback pro sufixo do SKU
                // ({base}-{N}), mantendo o comportamento anterior.
                const sufixoNum2 = (sku: string) => {
                    const m = (sku || "").match(/-(\d+)$/);
                    return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER;
                };
                varV2.sort((a, b) => {
                    const oa = a.ordem;
                    const ob = b.ordem;
                    if (oa != null && ob != null && oa !== ob) return oa - ob;
                    if (oa != null && ob == null) return -1;
                    if (oa == null && ob != null) return 1;
                    return sufixoNum2(a.sku) - sufixoNum2(b.sku);
                });

                variacoesV2.setVariacoes(varV2);
            }

            setLoading(false);
        };

        init();
    }, [needInit]);

    useEffect(() => {
        fetchCategorias();
    }, []);

    useEffect(() => {
        if (!permissoesPlano["CONTROLE_DE_ESTOQUE"]?.permitido) {
            setTemEstoque(false);
        }
    }, [permissoesPlano, produto.variacoes]);

    async function processaVariacoes(variacoes) {
        const ListasResult = await ApiListasDePreco.getListas();
        setListasDePreco(ListasResult);

        // Keep track of existing prices to preserve them
        const existingPrices = {};

        // Store all existing prices by variacao and tabela IDs
        variacoes.forEach((variacao) => {
            if (variacao.precos && variacao.precos.length) {
                existingPrices[variacao.id] = {};
                variacao.precos.forEach((preco) => {
                    existingPrices[variacao.id][preco.id_tabela] = preco.preco;
                });
            }
        });

        // Update variacaoUnica prices while preserving existing ones 
        variacaoUnica.precos = [];
        ListasResult.forEach((tabela) => {
            const tabela_preco = {
                id: "0",
                id_variacao: variacaoUnica.id,
                id_tabela: tabela.id,
                preco: "0",
            };

            // If there's an existing price for this tabela, use it
            if (produto.variacoes.length > 0) {
                const existingVariacao = produto.variacoes[0];
                if (existingVariacao.precos) {
                    const existingPrice = existingVariacao.precos.find(
                        (p) => Number(p.id_tabela) === Number(tabela.id)
                    );
                    if (existingPrice) {
                        tabela_preco.preco = existingPrice.preco;
                    }
                }
            }

            variacaoUnica.precos.push(tabela_preco);
        });

        // Update variacoes prices
        variacoes.forEach((variacao) => {
            const savedPrices = existingPrices[variacao.id] || {};
            variacao.precos = [];

            if (variacao.estoque !== null) setTemEstoque(true);

            ListasResult.forEach((tabela) => {
                const tabela_preco = {
                    id: "0",
                    id_variacao: variacao.id,
                    id_tabela: tabela.id,
                    preco: savedPrices[tabela.id] || "0", // Use existing price if available
                };

                // Only check API data if we don't have a saved price
                if (!savedPrices[tabela.id]) {
                    const precos_filtrados = produto.variacoes_precos
                        ?.filter(
                            (preco) =>
                                Number(preco.id_variacao) === Number(variacao.id) &&
                                Number(preco.id_tabela) === Number(tabela_preco.id_tabela)
                        ) || [];

                    if (precos_filtrados.length > 0) {
                        const preco_encontrado = precos_filtrados[0];
                        tabela_preco.id = preco_encontrado.id;
                        tabela_preco.preco = preco_encontrado.preco;
                    }
                }

                variacao.precos.push(tabela_preco);
            });
        });

        setProduto({
            ...produto,
            variacoes: [...variacoes],
        });
    }

    useEffect(() => {
        if (novaCategoria) {
            setProduto({
                ...produto,
                id_pasta: novaCategoria.toString(),
            });
        }
    }, [novaCategoria]);

    useEffect(() => {
        variacaoUnica.precos = [];
        listasDePreco.forEach((tabela) => {
            const tabela_preco = {
                id: "0",
                id_variacao: variacaoUnica.id,
                id_tabela: tabela.id,
                preco:
                    produto.variacoes.length > 0
                        ? produto.variacoes[0].precos
                            .filter(
                                (preco) => Number(preco.id_tabela) === Number(tabela.id)
                            )
                            .reduce((a, preco) => preco.preco, "0")
                        : "0",
            };
            variacaoUnica.precos.push(tabela_preco);
        });
    }, [listasDePreco]);

    useEffect(() => {
        if (permissoesPlano && permissoesPlano['FOTOS']) {
            if (
                !permissoesPlano['FOTOS'].ilimitado &&
                permissoesPlano['FOTOS'].limitador < produto.fotos.length + 1
            ) {
                setFotosBloqueadas(true);
                setMidiasBox(false);
            } else {
                setFotosBloqueadas(false);
            }
        }
    }, [produto.fotos.length, permissoesPlano]);

    useEffect(() => {
        if (permissoesPlano && permissoesPlano["VARIACOES_NO_CADASTRO_DE_PRODUTO"]?.permitido) {
            const activeVariations = produto.variacoes.filter(
                (v) => v.ativo === "1" || v.ativo === 1
            );
            if (
                !permissoesPlano["VARIACOES_NO_CADASTRO_DE_PRODUTO"].ilimitado &&
                permissoesPlano["VARIACOES_NO_CADASTRO_DE_PRODUTO"].limitador < activeVariations.length + 1
            ) {
                setVariacoesBloqueadas(true);
            } else {
                setVariacoesBloqueadas(false);
            }
        }
    }, [produto, permissoesPlano]);

    useEffect(() => {
        if (permissoesPlano && permissoesPlano["PRODUTOS"]?.permitido) {
            produtosApi()
                .verificarLimiteProdutos()
                .then(() => {
                    setProdutosBloqueados(false);
                })
                .catch(() => {
                    setProdutosBloqueados(true);
                });
        }
    }, [produto.variacoes.length, permissoesPlano]);

    function handleQuantidadeMinima(newValue: string) {
        const parsedValue = parseInt(newValue) || 1;
        setAuxAvancado({
            ...auxAvancado,
            quantidade_minima: newValue,
        });
        setProduto({
            ...produto,
            quantidade_minima: parsedValue,
        });
    }

    function handleMultiplicador(newValue: string) {
        const parsedValue = parseInt(newValue) || 1;
        setAuxAvancado({
            ...auxAvancado,
            multiplicador: newValue,
        });
        setProduto({
            ...produto,
            multiplicador: parsedValue,
        });
    }

    // Adicione este useEffect para sincronizar quando temVariacao mudar
    useEffect(() => {
        if (!temVariacao && produto.variacoes.length > 0) {
            // Ao mudar para modo sem variação, pega os preços da primeira variação
            const primeiraVariacao = produto.variacoes[0];
            if (primeiraVariacao && primeiraVariacao.precos) {
                setVariacaoUnica({
                    ...variacaoUnica,
                    estoque: primeiraVariacao.estoque,
                    // Mantenha os preços da primeira variação
                    precos: [...primeiraVariacao.precos],
                });
            }
        } else if (temVariacao && produto.variacoes.length > 0) {
            // Ao mudar para modo com variação, atualiza a primeira variação com dados da variacaoUnica
            const variacoes = [...produto.variacoes];
            if (variacaoUnica.precos && variacoes[0]) {
                variacoes[0].precos = [...variacaoUnica.precos];
                variacoes[0].estoque = variacaoUnica.estoque;

                setProduto({
                    ...produto,
                    variacoes: variacoes,
                });
            }
        }
    }, [temVariacao]);

    // Add this useEffect to better synchronize variacaoUnica and product variations
    useEffect(() => {
        if (!temVariacao && produto.variacoes.length > 0) {
            // When switching to single variation mode, copy prices from first variation
            const primeiraVariacao =
                produto.variacoes.find((v) => Number(v.ativo) === 1) ||
                produto.variacoes[0];
            if (primeiraVariacao && primeiraVariacao.precos) {
                // Create a deep copy to avoid reference issues
                const precosCopy = JSON.parse(JSON.stringify(primeiraVariacao.precos));

                setVariacaoUnica({
                    ...variacaoUnica,
                    estoque: primeiraVariacao.estoque,
                    precos: precosCopy,
                });
            }
        } else if (temVariacao && produto.variacoes.length > 0) {
            // When switching to multiple variations mode, update first variation with variacaoUnica data
            const variacoes = JSON.parse(JSON.stringify(produto.variacoes));
            const activeVariacao = variacoes.find((v) => Number(v.ativo) === 1);

            if (variacaoUnica.precos && activeVariacao) {
                activeVariacao.precos = JSON.parse(
                    JSON.stringify(variacaoUnica.precos)
                );
                activeVariacao.estoque = variacaoUnica.estoque;

                setProduto({
                    ...produto,
                    variacoes: variacoes,
                });
            }
        }
    }, [temVariacao]);

    // Add this function to handle adding a new price list properly
    const handleAddNewPriceList = (newPriceList) => {
        // Only proceed if it's a new price list object
        if (typeof newPriceList !== "object" || newPriceList === null) {
            return;
        }

        // Add the new price list to the state
        setListasDePreco((prevLists) => {
            const newList = [...prevLists, newPriceList];
            return newList;
        });

        // Add price entries for all variations
        if (produto.variacoes && produto.variacoes.length > 0) {
            const updatedVariacoes = JSON.parse(JSON.stringify(produto.variacoes));

            updatedVariacoes.forEach((variacao) => {
                // Check if price entry for this list already exists
                const existingPrice = variacao.precos.find(
                    (preco) => preco.id_tabela === newPriceList.id
                );

                // Only add if it doesn't exist
                if (!existingPrice) {
                    variacao.precos.push({
                        id: "0",
                        id_variacao: variacao.id,
                        id_tabela: newPriceList.id,
                        preco: "0",
                    });
                }
            });

            setProduto({
                ...produto,
                variacoes: updatedVariacoes,
            });
        }

        // Add price entry for variacaoUnica if in single variation mode
        if (!temVariacao) {
            const updatedVariacaoUnica = {...variacaoUnica};

            // Check if price entry already exists
            const existingPrice = updatedVariacaoUnica.precos.find(
                (preco) => preco.id_tabela === newPriceList.id
            );

            // Only add if it doesn't exist
            if (!existingPrice) {
                updatedVariacaoUnica.precos.push({
                    id: "0",
                    id_variacao: updatedVariacaoUnica.id,
                    id_tabela: newPriceList.id,
                    preco: "0",
                });

                setVariacaoUnica(updatedVariacaoUnica);
            } else {
            }
        }
    };

    useEffect(() => {
        // Apenas preencher campos quando o modal abrir, se não estiverem já preenchidos
        if (modalGerarDescricaoIa) {
            // Só preenche o nome se estiver vazio (respeita o cache)
            if (!nomeProdutoIA && produto.nome) {
                setNomeProdutoIA(produto.nome);
            }
            
            // Só preenche a imagem se estiver vazia E não foi removida manualmente
            if (!imagemProdutoIA && !imagemRemovidaManualmente && produto.fotos && produto.fotos.length > 0) {
                const imagemPrincipal = produto.fotos[0];
                let imagemSrc = "";
                
                if (imagemPrincipal.base64 && imagemPrincipal.base64.trim() !== "") {
                    if (imagemPrincipal.base64.startsWith('data:image')) {
                        imagemSrc = imagemPrincipal.base64;
                    } else {
                        imagemSrc = `data:image/jpeg;base64,${imagemPrincipal.base64}`;
                    }
                } else if (imagemPrincipal.imagem_externa_2 && imagemPrincipal.imagem_externa_2.trim() !== "") {
                    imagemSrc = imagemPrincipal.imagem_externa_2;
                } else if (imagemPrincipal.imagem_externa && imagemPrincipal.imagem_externa.trim() !== "") {
                    imagemSrc = imagemPrincipal.imagem_externa;
                }
                
                if (imagemSrc) {
                    setImagemProdutoIA(imagemSrc);
                }
            }
        }
        // Removido: não limpar mais os campos quando o modal fechar
    }, [modalGerarDescricaoIa, produto.nome, produto.fotos, nomeProdutoIA, imagemProdutoIA, imagemRemovidaManualmente]);

    const isBotaoDesabilitado = () => {
        return gerandoDescricaoIA;
    };

    const getTextoBotao = () => {
        if (gerandoDescricaoIA) {
            return "Gerando...";
        }
        
        return "Gerar nome e descrição";
    };

    const getInfoTokens = () => {
        const validacao = validarTokensSuficientes(false);
        const tokensComImagem = 1300;
        const tokensSemImagem = 400;
        
        return `Você tem ${validacao.tokensDisponiveis.toLocaleString("pt-BR")} tokens disponíveis para uso`;
    };


    const handleGerarDescricaoIA = async () => {
        const temImagem = !!imagemProdutoIA;
        
        const validacao = validarTokensSuficientes(temImagem);
        
        const dataRenovacao = new Date(empresa.update_token_ia);
        dataRenovacao.setDate(dataRenovacao.getDate() + 30);

        if(!validacao.suficiente){
            const isPlanoBloqueado = empresa.plano_mais_alo === 1;
            
            Swal.fire({
                title: isPlanoBloqueado ? "Atenção" : "Tokens Insuficientes",
                html: `
                    <p><strong>Você não possui tokens suficientes para esta operação!</strong></p>
                    <br>
                    <div style="text-align: left;">
                        <p><strong>Tokens necessários (estimativa):</strong> ${validacao.tokensNecessarios.toLocaleString('pt-BR')}</p>
                        <p><strong>Tokens disponíveis:</strong> ${validacao.tokensDisponiveis.toLocaleString('pt-BR')}</p>
                        <p><strong>Descrição com imagem:</strong> ${temImagem ? 'Sim' : 'Não'}</p>
                        <br>
                        <p>${isPlanoBloqueado ? 'Aguarde' : 'Entre em contato com nosso atendimento para realizar o upgrade do seu plano ou aguarde'} até dia ${dataRenovacao.toLocaleDateString("pt-BR")} para a renovação automática do seus tokens.</p>
                    </div>
                `,
                icon: "warning",
                confirmButtonText: "Entendi",
            });
            return;
        }

        // Processar a imagem para garantir formato correto
        let imagemProcessada = imagemProdutoIA;
        
        if (imagemProdutoIA && imagemProdutoIA.trim() !== '') {
            const isExternalUrl = imagemProdutoIA.startsWith('http://') || imagemProdutoIA.startsWith('https://');
            const isDataUrl = imagemProdutoIA.startsWith('data:image');
            
            if (isExternalUrl) {
                imagemProcessada = imagemProdutoIA.replace('{size}', '413');
            } else if (!isDataUrl) {
                imagemProcessada = `data:image/jpeg;base64,${imagemProdutoIA}`;
            } else {
                imagemProcessada = imagemProdutoIA;
            }
        }

        const dados = {
            nomeProdutoIA,
            tomDeVoz,
            caracteristicasBeneficios,
            instrucoesEspeciais,
            quantidadePalavrasMin,
            quantidadePalavrasMax,
            imagemProdutoIA: imagemProcessada
        };

        setGerandoDescricaoIA(true);

        try {
            const result = await produtoApi().gerarDescricaoIA(dados);            
            
            // Verificar erro de limite atingido
            if (result?.error === "Limite de tokens atingido") {
                Swal.fire({
                    title: "Limite de Tokens Atingido",
                    html: `
                    <p><strong>Você atingiu o limite de tokens disponíveis no seu plano!</strong></p>
                        <br>
                    <div style="text-align: left;">
                        <p><strong>Tokens atuais:</strong> ${result.tokens_atuais?.toLocaleString('pt-BR') || 'N/A'}</p>
                        <p><strong>Limite do plano:</strong> ${result.limite?.toLocaleString('pt-BR') || 'N/A'}</p>
                        <br>
                        <p>Entre em contato com nosso atendimento para realizar o upgrade do seu plano ou aguarde até dia x para a renovação automática dos seus tokens.</p>
                    </div>
                    `,
                    icon: "warning",
                    confirmButtonText: "Entendi",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
                setModalGerarDescricaoIa(false);
                return;
            }
            
            // Verificar erro de tokens insuficientes para a operação
            if (result?.error === "Tokens insuficientes para esta operação") {
                Swal.fire({
                    title: "Tokens Insuficientes",
                    html: `
                    <p><strong>Você não possui tokens suficientes para esta operação!</strong></p>
                        <br>
                    <div style="text-align: left;">
                        <p><strong>Tokens necessários (estimativa):</strong> ${result.tokens_estimados?.toLocaleString('pt-BR') || 'N/A'}</p>
                        <p><strong>Tokens disponíveis:</strong> ${result.tokens_disponiveis?.toLocaleString('pt-BR') || 'N/A'}</p>
                        <p><strong>Tipo de operação:</strong> ${result.tem_imagem ? 'Com imagem' : 'Sem imagem'}</p>
                        <br>
                        <p>Entre em contato com nosso atendimento para realizar o upgrade do seu plano.</p>
                    </div>
                    `,
                    icon: "warning",
                    confirmButtonText: "Entendi",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
                setModalGerarDescricaoIa(false);
                return;
            }
            
            setResultadoNomeIA(result.nome ?? nomeProdutoIA);
            setResultadoDescricaoIA(result.descricao ?? "");
            
            if (result.tokens) {
                setTokensUtilizados({
                    prompt_tokens: result.tokens.prompt_tokens,
                    completion_tokens: result.tokens.completion_tokens,
                    total_tokens: result.tokens.total_tokens
                });
                
                decrementarTokens(result.tokens.total_tokens);
                
                atualizarTokens();
            }

            setModalGerarDescricaoIa(false);
            setModalResultadoIA(true);
        } catch (e) {
            Swal.fire({
                title: "Erro",
                text: "Ocorreu um erro ao gerar a descrição. Por favor, tente novamente.",
                icon: "error",
                confirmButtonText: "Ok",
            });
        } finally {
            setGerandoDescricaoIA(false);
        }
    };
    return (
        <>
            <ViewContainer theme={theme}>
                {loading ? (
                    <SkeletonCadastroProduto/>
                ) : (
                    <>
                        <div className="left">
                            <Tabs
                                tabs={tabs}
                                value={activeTab}
                                onChange={(newValue) => {
                                    setActiveTab(newValue);
                                    if (newValue !== "avancado") {
                                        setTabs(tabs.filter((tab) => tab.value !== "avancado"));
                                    }
                                    if (newValue !== "informacoes") {
                                        setForceTab(null);
                                    }
                                }}
                            />

                            {activeTab == "informacoes" && (
                                <div className="cadastro">
                                    <div className="tem-variacao">
                                        <div className="topo">
                                            <Toggle
                                                value={temVariacao}
                                                onChange={(newValue) => {
                                                    //se todas as variacoes estiverem inativas cria uma variacao

                                                    let temVariacao = false;

                                                    produto.variacoes.forEach((variacao) => {
                                                        if (Number(variacao.ativo) === 1) {
                                                            temVariacao = true;
                                                        }
                                                    });

                                                    if (!temVariacao) {
                                                        novaVariacao();
                                                    }

                                                    setTemVariacao(newValue);
                                                }}
                                                disabled={!config_integracao.permitir_produtos}
                                            />
                                            <span className="fonteTexto">Esse produto tem variação?</span>
                                        </div>
                                        <div className="texto-variacao fonteRotulos">
                                            Ative essa opção acima se o seu produto possui variação de
                                            características. Por exemplo: tamanho, cor e etc.
                                        </div>
                                        {temVariacao && (
                                            <>
                                                <div className="tem-estoque">
                                                    <label>
                                                        <Toggle
                                                            value={temEstoque}
                                                            onChange={(newValue) => {
                                                                setTemEstoque(newValue);
                                                            }}
                                                            disabled={
                                                                !config_integracao.permitir_produtos ||
                                                                !permissoesPlano["CONTROLE_DE_ESTOQUE"]?.permitido
                                                            }
                                                        />
                                                    </label>
                                                    <span className="fonteTexto">Gerenciar estoque desse produto?</span>
                                                    <PopoverInfo
                                                        width="100rem"
                                                        mensagem="Este campo desativado é considerado estoque ilimitado."
                                                    />
                                                    {!permissoesPlano["CONTROLE_DE_ESTOQUE"]?.permitido && (
                                                        <LockedIcon
                                                            mensagem="Recurso disponível a partir do plano Essencial."
                                                            width="2.6rem"
                                                            className="blocked"
                                                        />
                                                    )}
                                                </div>
                                                <div className="texto-variacao fonteRotulos">
                                                    Para produtos com variações, o controle de estoque é vinculado às variações.
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <Form id={""} setFormValid={setIsValid} ref={formRef}>
                                        <div style={temVariacao ? { display: "flex", gap: "2rem", alignItems: "flex-end" } : {}}>
                                            <div className="input" style={temVariacao ? { flex: 1 } : {}}>
                                                <Input
                                                    label="Nome do produto"
                                                    type="text"
                                                    name="nome"
                                                    value={produto.nome}
                                                    onChange={(newValue) => {
                                                        setProduto(prevProduto => ({
                                                            ...prevProduto,
                                                            nome: newValue,
                                                        }));
                                                    }}
                                                    placeholder="Nome"
                                                    error=""
                                                    disabled={!config_integracao.permitir_produtos}
                                                    maxLength={64}
                                                    required={true}
                                                />
                                            </div>
                                            {temVariacao && (
                                                <div className="sku-peso" style={{ flex: 1, margin: 0 }}>
                                                    <div className="sku" style={{ width: "100%" }}>
                                                        <Input
                                                            label="SKU | produto"
                                                            type="text"
                                                            name="sku"
                                                            showMaxLength={false}
                                                            value={produto.referencia}
                                                            onChange={(newValue) => {
                                                                setProduto({
                                                                    ...produto,
                                                                    referencia: newValue,
                                                                });
                                                            }}
                                                            placeholder="0000XXX"
                                                            error=""
                                                            maxLength={64}
                                                            disabled={!config_integracao.permitir_produtos}
                                                            required={true}
                                                        />
                                                        {config_integracao.permitir_produtos ? (
                                                            <div
                                                                className="gerar"
                                                                onClick={() => {
                                                                    setProduto({
                                                                        ...produto,
                                                                        referencia: generateRandomString(),
                                                                    });
                                                                }}
                                                            >
                                                                <div className="gerar-texto fonteTexto">Gerar</div>
                                                            </div>
                                                        ) : (
                                                            <div></div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="textarea">
                                            <div className="titulo-campo">
                                                <div className="label fonteTexto">Descrição</div>
                                                <div
                                                    className="gerar-descricao-ia fonteRotulos"
                                                    style={!config_integracao.permitir_produtos ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                                                    onClick={() => {
                                                        if (!config_integracao.permitir_produtos) return;
                                                        setModalGerarDescricaoIa(true);
                                                    }}
                                                >
                                                    <DescricaoIA className="descricao-ia" />
                                                    <span>Gerar descrição com IA</span>
                                                </div>
                                            </div>
                                            
                                            <ReactQuill
                                                className="quill-editor"
                                                formats={["bold", "italic", "underline", "list"]}
                                                value={produto.descricao}
                                                readOnly={!config_integracao.permitir_produtos}
                                                onChange={(newValue) => {
                                                    setProduto(prevProduto => ({
                                                        ...prevProduto,
                                                        descricao: newValue,
                                                    }));
                                                }}
                                                style={
                                                    !config_integracao.permitir_produtos
                                                        ? {opacity: 0.5}
                                                        : {}
                                                }
                                            ></ReactQuill>
                                        </div>
                                        <div className="sku-peso" style={temVariacao ? { display: "none" } : {}}>
                                            <div className="sku">
                                                <Input
                                                    label="SKU"
                                                    type="text"
                                                    name="sku"
                                                    showMaxLength={false}
                                                    value={produto.referencia}
                                                    onChange={(newValue) => {
                                                        setProduto({
                                                            ...produto,
                                                            referencia: newValue,
                                                        });
                                                    }}
                                                    placeholder="0000XXX"
                                                    error=""
                                                    maxLength={64}
                                                    disabled={!config_integracao.permitir_produtos}
                                                    required={true}
                                                />
                                                {config_integracao.permitir_produtos ? (
                                                    <div
                                                        className="gerar"
                                                        onClick={() => {
                                                            setProduto({
                                                                ...produto,
                                                                referencia: generateRandomString(),
                                                            });
                                                        }}
                                                    >
                                                        <div className="gerar-texto fonteTexto">Gerar</div>
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                            <div className="peso" style={temVariacao ? { display: "none" } : {}}>
                                                <Input
                                                    label="Peso (g)"
                                                    type="number"
                                                    name="peso"
                                                    value={produto.peso}
                                                    required={!temVariacao}
                                                    onChange={(newValue) => {
                                                        setProduto({
                                                            ...produto,
                                                            peso: newValue,
                                                        });
                                                    }}
                                                    placeholder="0"
                                                    step={"any"}
                                                    disabled={!config_integracao.permitir_produtos}
                                                    max={999999}
                                                    showMaxLength={false}
                                                />
                                                <div className="conversor-peso fonteRotulos">
                                                    {produto.peso}g = {(Number(produto.peso) / 1000).toFixed(3).replace('.', ',')}kg
                                                </div>
                                            </div>
                                        </div>
                                        <div className="categoria">
                                            <Select
                                                label="Categoria"
                                                sizeLabel="medium"
                                                name="categoria"
                                                value={produto.id_pasta}
                                                onChange={(newValue) => {
                                                    setProduto({
                                                        ...produto,
                                                        id_pasta: newValue,
                                                    });
                                                    setCloseCategoriasSignal((s) => s + 1);
                                                }}
                                                placeholder="Selecione uma categoria"
                                                options={categorias}
                                                disabled={!config_integracao.permitir_produtos}
                                                required={true}
                                            />
                                            <div
                                                className="mais fonteTexto"
                                                style={!podeEditarProduto ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                                                onClick={() => {
                                                    if (!podeEditarProduto) return;
                                                    setForceTab({ tab: "categorias", ts: Date.now() });
                                                    if (window.innerWidth <= 1025) {
                                                        setTimeout(() => {
                                                            categoriasTabRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                                                        }, 100);
                                                    }
                                                }}
                                            >
                                                <Plus className="plus"/>
                                                Criar e editar
                                            </div>
                                        </div>
                                    </Form>
                                    {!temVariacao &&
                                        !loading &&
                                        variacaoUnica.precos.length > 0 && (
                                            <>
                                                <div className="precos-lista-container">
                                                    <div className="precos-content">
                                                        <div className="precos-header">
                                                            {listasDePreco.map((tabela, index) => {
                                                                const truncateText = (text) => {
                                                                    return text.length > 12 ? text.substring(0, 12) + "..." : text;
                                                                };
                                                                return (
                                                                    <div className="header-item"
                                                                         title={tabela.descricao} key={index}>
                                                                        <div className="titulo-lista fonteTexto">
                                                                            Preço {truncateText(tabela.descricao)}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div className="precos-inputs">
                                                            {listasDePreco.map((tabela, index) => {
                                                                return (
                                                                    <div className="preco-item" key={index}>
                                                                        <Input
                                                                            type="text"
                                                                            name="preco"
                                                                            disabled={
                                                                                !config_integracao.permitir_produtos
                                                                            }
                                                                            mask={{
                                                                                mask: currencyMask,
                                                                                unmask: unmaskToInt,
                                                                                param: tabela.moeda,
                                                                            }}
                                                                            value={variacaoUnica.precos && variacaoUnica.precos[index] ? variacaoUnica.precos[index].preco : "0"}
                                                                            onChange={(newValue) => {
                                                                                let variacao = {
                                                                                    ...variacaoUnica,
                                                                                };
                                                                                if (variacao.precos && variacao.precos[index]) {
                                                                                    variacao.precos[index].preco = newValue;
                                                                                }
                                                                                setVariacaoUnica(variacao);
                                                                            }}
                                                                            placeholder="Preço"
                                                                        />
                                                                    </div>
                                                                );
                                                            })}
                                                            <div className="nova-lista-header">
                                                                <div
                                                                    className="mais fonteTexto"
                                                                    style={!config_integracao.permitir_produtos ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                                                                    onClick={() => {
                                                                        if (!config_integracao.permitir_produtos) return;
                                                                        if (
                                                                            !permissoesPlano[
                                                                                "TABELAS_DE_PRECOS"
                                                                                ]?.permitido
                                                                        ) {
                                                                            window.location.href =
                                                                                "/perfil/usuarios/planos";
                                                                            return;
                                                                        }
                                                                        setModalListaDePreco(true);
                                                                    }}
                                                                >
                                                                    {!permissoesPlano["TABELAS_DE_PRECOS"]?.permitido ? (
                                                                        <LockedIcon
                                                                            mensagem="Recurso disponível a partir do plano Essencial."
                                                                            width="20px"
                                                                            className="blocked"
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <Plus className="plus"/>
                                                                            Criar e editar
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    {!temVariacao && (
                                        <>
                                            <div className="linha"/>
                                            <div className="tem-estoque">
                                                <label>
                                                    <Toggle
                                                        value={temEstoque}
                                                        onChange={(newValue) => {
                                                            setTemEstoque(newValue);
                                                            if (newValue && estoqueVazio(variacaoUnica.estoque)) {
                                                                setVariacaoUnica({...variacaoUnica, estoque: "0"});
                                                            }
                                                        }}
                                                        disabled={
                                                            !config_integracao.permitir_produtos ||
                                                            !permissoesPlano["CONTROLE_DE_ESTOQUE"]?.permitido
                                                        }
                                                    />
                                                </label>
                                                <span className="fonteTexto">Gerenciar estoque desse produto?</span>
                                                <PopoverInfo
                                                    width="100rem"
                                                    mensagem="Este campo desativado é considerado estoque ilimitado."
                                                />
                                                {
                                                    !permissoesPlano["CONTROLE_DE_ESTOQUE"]?.permitido && (
                                                        <LockedIcon
                                                            mensagem="Recurso disponível a partir do plano Essencial."
                                                            width="2.6rem"
                                                            className="blocked"
                                                        />
                                                    )
                                                }
                                            </div>
                                        </>
                                    )}
                                    {temEstoque &&
                                        variacaoUnica.precos.length > 0 &&
                                        !temVariacao && (
                                            <div className="estoque-unico">
                                                <Input
                                                    label="Estoque"
                                                    type="text"
                                                    name="nome"
                                                    disabled={!config_integracao.permitir_produtos}
                                                    value={variacaoUnica.estoque}
                                                    onChange={(newValue) => {
                                                        setVariacaoUnica({
                                                            ...variacaoUnica,
                                                            estoque: newValue,
                                                        });
                                                    }}
                                                    placeholder="Estoque"
                                                />
                                            </div>
                                        )}

                                    {/* Toggle de Destaque */}
                                    <div className="linha"/>
                                    <div className="tem-destaque">
                                        <label>
                                            <Toggle
                                                value={temDestaque}
                                                onChange={(newValue) => {
                                                    setTemDestaque(newValue);
                                                }}
                                                disabled={
                                                    !permissoesPlano["TAG_DESTAQUE"]?.permitido ||
                                                    !podeEditarProduto
                                                }
                                            />
                                        </label>
                                        <span className="fonteTexto">Quer destacar esse produto?</span>
                                        <PopoverInfo
                                            width="100rem"
                                            mensagem="Selecione uma tag de destaque para seu produto aparecer em evidência no catálogo."
                                        />
                                        {
                                            !permissoesPlano["TAG_DESTAQUE"]?.permitido && (
                                                <LockedIcon
                                                    mensagem="Recurso disponível a partir do plano Essêncial."
                                                    width="2.6rem"
                                                    className="blocked"
                                                />
                                            )
                                        }
                                    </div>
                                    {temDestaque && (
                                        <div className="destaque-select">
                                            <Select
                                                label="Tags de destaque"
                                                className="select-tag"
                                                disabled={!podeEditarProduto}
                                                options={[
                                                    ...tagsDestaque
                                                        .filter(tag => tag.ativo === 1)
                                                        .map(tag => ({
                                                            name: tag.nome_tag,
                                                            value: tag.id.toString(),
                                                        })),
                                                    { name: "+ Criar e editar tags", value: "editar" }
                                                ]}
                                                value={tagSelecionada}
                                                onChange={(value) => {
                                                    if (value === "editar") {
                                                        setModalTagsOpen(true);
                                                    } else {
                                                        setTagSelecionada(value);
                                                    }
                                                }}
                                                placeholder="Selecione uma tag"
                                            />    
                                            <span className="textTags fonteRotulos">Ao criar uma promoção no catálogo, a tag de promoção é aplicada automaticamente e aparece somente nos produtos que terão a regra ativa.</span>
                                        </div>
                                    )}

                                    {/* Toggle de Tags de característica */}
                                    <div className="linha"/>
                                    <div className="tem-destaque">
                                        <label>
                                            <Toggle
                                                value={temCaracteristica}
                                                onChange={(newValue) => {
                                                    setTemCaracteristica(newValue);
                                                }}
                                                disabled={
                                                    !permissoesPlano["TAG_CARACTERISTICA"]?.permitido ||
                                                    !config_integracao.permitir_produtos
                                                }
                                            />
                                        </label>
                                        <span className="fonteTexto">Adicionar tags de características ao produto?</span>
                                        {
                                            !permissoesPlano["TAG_CARACTERISTICA"]?.permitido && (
                                                <LockedIcon
                                                    mensagem="Recurso disponível apenas para o plano Avançado"
                                                    width="2.6rem"
                                                    className="blocked"
                                                />
                                            )
                                        }
                                    </div>
                                    {temCaracteristica && (
                                        <div className="caracteristicas-box">
                                            <TagValueInput
                                                label="Tags de características"
                                                values={caracteristicas}
                                                onChange={setCaracteristicas}
                                                suggestions={sugestoesCaracteristicas}
                                                disabled={!config_integracao.permitir_produtos}
                                                placeholder="Informe as características separadas por vírgula ou enter"
                                                helperText="Informe os valores separados por vírgula ou enter."
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeTab === "midias" && (
                                <div className="midias">
                                    {config_integracao.permitir_imagens && (
                                        <div className="center">
                                            <div
                                                className="adicionar_produto"
                                                onClick={() => {
                                                    if (fotosBloqueadas) {
                                                        Swal.fire({
                                                            title: "Erro!",
                                                            text: "Você atingiu o limite de fotos para o seu plano",
                                                            icon: "error",
                                                            confirmButtonText: "Ok",
                                                        });
                                                        return;
                                                    }

                                                    setMidiasBox(!midiasBox);
                                                    // Dispara automaticamente o upload de foto
                                                    setTimeout(() => {
                                                        midiasBoxRef.current?.triggerPhotoUpload();
                                                    }, 100);
                                                }}
                                            >
                                                <div className="pai">
                                                    {fotosBloqueadas ? (
                                                        <LockedIcon
                                                            mensagem="Você atingiu o limite de fotos do produto no seu plano, faça o upgrade."
                                                            className="locked"
                                                            width="8rem"
                                                        />
                                                    ) : (
                                                        <Plus className="plus"/>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {produto.fotos.map((foto, index) => {
                                        return (
                                            <div
                                                className="imagem"
                                                onMouseEnter={() => {
                                                    if (config_integracao.permitir_imagens)
                                                        setMouseSobreImagem(true);
                                                }}
                                                onMouseLeave={() => {
                                                    if (config_integracao.permitir_imagens) {
                                                        setMouseSobreImagem(false);
                                                    }
                                                }}
                                            >
                                                <div
                                                    className={`icone-apagar ${
                                                        mouseSobreImagem ? "visivel" : "invisivel"
                                                    }`}
                                                    onClick={() => {
                                                        removeImagem(index);
                                                    }}
                                                >
                                                    <Plus/>
                                                </div>
                                                {foto.tipo == 1 && (
                                                    <div
                                                        className={`melhorar-ia ${
                                                            mouseSobreImagem ? "visivel" : "invisivel"
                                                        }`}
                                                        title="Melhorar com IA"
                                                        onClick={() => abrirMelhorarFotoIA(index)}
                                                    >
                                                        <div className="conteudo-melhorar">
                                                            <DescricaoIA className="descricao-ia" />
                                                            <span>Melhorar com IA</span>
                                                        </div>
                                                    </div>
                                                )}
                                                {index != 0 && (
                                                    <div
                                                        className={`icone-esquerda ${
                                                            mouseSobreImagem ? "visivel" : "invisivel"
                                                        }`}
                                                        onClick={() => {
                                                            moveImagemEsquerda(index);
                                                        }}
                                                    >
                                                        <VoltarIcon/>
                                                    </div>
                                                )}
                                                {index != produto.fotos.length - 1 && (
                                                    <div
                                                        className={`icone-direita ${
                                                            mouseSobreImagem ? "visivel" : "invisivel"
                                                        }`}
                                                        onClick={() => {
                                                            moveImagemDireita(index);
                                                        }}
                                                    >
                                                        <VoltarIcon/>
                                                    </div>
                                                )}
                                                {(foto.tipo == 1 && (
                                                    <ImgWithLoading
                                                        src={
                                                            foto.imagem_externa_2
                                                                ? foto.imagem_externa_2
                                                                : foto.imagem_externa
                                                                    ? foto.imagem_externa
                                                                    : foto.base64
                                                        }
                                                        alt=""
                                                    />
                                                )) || (
                                                    <ImgWithLoading
                                                        src={obterMiniaturaVideoYouTube(
                                                            foto.imagem_externa || foto.imagem
                                                        )}
                                                        alt=""
                                                    />
                                                )}
                                                {temVariacao && variacoesV2.niveisVariacao.length > 1 && (
                                                    <div className="imagem-selector">
                                                        <MediaVariationSelector
                                                            valorVariacao={foto.valor_variacao}
                                                            valoresDisponiveis={variacoesV2.niveisVariacao[0]?.valores || []}
                                                            valoresOcupados={produto.fotos
                                                                .filter((_: any, i: number) => i !== index)
                                                                .filter((f: any) => f.valor_variacao !== undefined && f.valor_variacao !== null)
                                                                .map((f: any) => f.valor_variacao)}
                                                            onChange={(valor) => {
                                                                const fotos = [...produto.fotos];
                                                                fotos[index] = { ...fotos[index], valor_variacao: valor };
                                                                // "Foto do produto" selecionado: mover para primeira posição
                                                                if (valor === "") {
                                                                    const [foto] = fotos.splice(index, 1);
                                                                    fotos.unshift(foto);
                                                                    fotos.forEach((f: any, i: number) => f.ordem = i);
                                                                }
                                                                setProduto({ ...produto, fotos });
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {activeTab === "avancado" && (
                                <>
                                    <div className="avancado">
                                        <div className="titulo-avancado fonteTexto">
                                            Para garantir a melhor experiência de compra em seu
                                            catálogo, recomendamos que as configurações avançadas só
                                            sejam alteradas se você entender a funcionalidade do
                                            recurso.
                                        </div>
                                        <div className="inputs-avancado">
                                            <div className="bloco-quantidade-minima">
                                                <span className="regra-titulo fonteTexto">
                                                    Regra de quantidade mínima de compra
                                                </span>
                                                {temVariacao && (
                                                    <div className="regra-radios">
                                                        {[
                                                            {valor: 0, texto: "Por variação"},
                                                            {valor: 1, texto: "Por produto"},
                                                        ].map(({valor, texto}) => (
                                                            <label key={valor}>
                                                                <Input
                                                                    type="radio"
                                                                    name="quantidade_minima_soma"
                                                                    value={String(valor)}
                                                                    checked={auxAvancado.quantidade_minima_soma === valor}
                                                                    disabled={
                                                                        !config_integracao.permitir_produtos ||
                                                                        !permissoesPlano["QUANTIDADES_MINIMAS_DE_COMPRA_POR_PRODUTO"]?.permitido
                                                                    }
                                                                    onChange={() =>
                                                                        setAuxAvancado({
                                                                            ...auxAvancado,
                                                                            quantidade_minima_soma: valor,
                                                                        })
                                                                    }
                                                                    placeholder={texto}
                                                                    label={texto}
                                                                />
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                                <Input
                                                    label="Quantidade"
                                                    type="text"
                                                    maxLength={5}
                                                    disabled={
                                                        !config_integracao.permitir_produtos ||
                                                        !permissoesPlano["QUANTIDADES_MINIMAS_DE_COMPRA_POR_PRODUTO"]?.permitido
                                                    }
                                                    labelIcon={
                                                        <PopoverInfo
                                                            width="78rem"
                                                            mensagem="O cliente não poderá comprar menos que essa quantidade por produto."
                                                        />
                                                    }
                                                    LockedIcon={
                                                        !permissoesPlano["QUANTIDADES_MINIMAS_DE_COMPRA_POR_PRODUTO"]?.permitido && (
                                                            <LockedIcon
                                                                mensagem="Recurso disponível a partir do plano Essencial."/>
                                                        )
                                                    }
                                                    name="quantidade_minima"
                                                    allowEmojis={false}
                                                    value={auxAvancado.quantidade_minima}
                                                    onChange={handleQuantidadeMinima}
                                                    placeholder="1"
                                                />
                                                <Input
                                                    label="Multiplicador"
                                                    maxLength={5}
                                                    type="text"
                                                    disabled={
                                                        !config_integracao.permitir_produtos ||
                                                        !permissoesPlano["MULTIPLICADOR"]?.permitido
                                                    }
                                                    labelIcon={
                                                        <PopoverInfo
                                                            width="86rem"
                                                            mensagem="Produtos com multiplicador 2, por exemplo, só podem ser comprados de 2 em 2."
                                                        />
                                                    }
                                                    LockedIcon={
                                                        !permissoesPlano["MULTIPLICADOR"]?.permitido && (
                                                            <LockedIcon
                                                                mensagem="Recurso disponível a partir do plano Essencial."/>
                                                        )
                                                    }
                                                    name="multiplicador"
                                                    allowEmojis={false}
                                                    value={auxAvancado.multiplicador}
                                                    onChange={handleMultiplicador}
                                                    placeholder="1"
                                                />
                                            </div>
                                            <div className="bloco-input">
                                                <Select
                                                    label="Cliente pode inserir observações?"
                                                    sizeLabel="medium"
                                                    name="observação"
                                                    disabled={
                                                        !config_integracao.permitir_produtos &&
                                                        !config_integracao.permitir_observacoes
                                                    }
                                                    value={auxAvancado.solicitar_observacao}
                                                    onChange={(newValue) => {
                                                        setAuxAvancado({
                                                            ...auxAvancado,
                                                            solicitar_observacao: newValue,
                                                        });
                                                    }}
                                                    options={[
                                                        {
                                                            name: "Sim",
                                                            value: "1",
                                                        },
                                                        {
                                                            name: "Não",
                                                            value: "0",
                                                        },
                                                    ]}
                                                />

                                                <Input
                                                    label="Data de publicação"
                                                    allowEmojis={false}
                                                    type="datetime-local"
                                                    disabled={
                                                        !config_integracao.permitir_produtos ||
                                                        !permissoesPlano["AGENDAR_PUBLICACAO_DE_PRODUTO"]?.permitido
                                                    }
                                                    onChange={(newValue) => {
                                                        setAuxAvancado({
                                                            ...auxAvancado,
                                                            data_publicacao: newValue,
                                                        });
                                                    }}
                                                    LockedIcon={
                                                        !permissoesPlano["AGENDAR_PUBLICACAO_DE_PRODUTO"]?.permitido && (
                                                            <LockedIcon
                                                                mensagem="Recurso disponível a partir do plano Essencial."/>
                                                        )
                                                    }
                                                    value={moment(
                                                        auxAvancado.data_publicacao,
                                                        "YYYY-MM-DD HH:mm"
                                                    ).format("YYYY-MM-DDTHH:mm")}
                                                    placeholder="2023-04-27T11:28"
                                                />
                                            </div>
                                            {config_integracao.integracao_bling && (
                                                <div className="bloco-input">
                                                    {/* Preenchido pela sincronização com o campo Localização do Bling */}
                                                    <Input
                                                        label="EAN"
                                                        type="text"
                                                        name="ean"
                                                        showMaxLength={false}
                                                        value={produto.ean ?? ""}
                                                        onChange={() => {}}
                                                        placeholder=""
                                                        error=""
                                                        disabled={true}
                                                    />
                                                </div>
                                            )}
                                            <div className="bloco-input">
                                                <Textarea
                                                    label="Observação interna"
                                                    sizeLabel="medium"
                                                    type="text"
                                                    maxLength={255}
                                                    disabled={
                                                        !config_integracao.permitir_produtos &&
                                                        !config_integracao.permitir_observacoes
                                                    }
                                                    labelIcon={
                                                        <PopoverInfo
                                                            width="100%"
                                                            mensagem="Está observação ficará visivel somente no cadastro e edição do produto, não aparecerá para o seu Cliente."
                                                        />
                                                    }
                                                    onChange={(newValue) => {
                                                        setAuxAvancado({
                                                            ...auxAvancado,
                                                            observacao_interna: newValue,
                                                        });
                                                    }}
                                                    value={auxAvancado.observacao_interna}
                                                    placeholder="Insira a observação interna aqui"
                                                />
                                            </div>
                                        </div>
                                        {produto.catalogos && produto.catalogos.length > 0 && (
                                            <div className="catalogos">
                                                <div className="linha"/>
                                                <div className="titulo-catalogos fonteTexto">
                                                    Catálogos em que o produto está adicionado:
                                                </div>
                                                {produto.catalogos.map((catalogo) => {
                                                    return <div className="nome fonteRotulos">- {catalogo}</div>;
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="middle hideMobile">
                            <div className="linha"/>
                        </div>
                        <div className="right">
                            <div ref={categoriasTabRef}>
                            <SlidingBox
                                active={(temVariacao || forceTab !== null) && activeTab == "informacoes"}
                                width="100%"
                                direction="right"
                            >
                                <VariacoesBoxV2
                                    niveisVariacao={variacoesV2.niveisVariacao}
                                    variacoes={variacoesV2.variacoes}
                                    tiposVariacao={tiposVariacao}
                                    listasDePreco={listasDePreco}
                                    temEstoque={temEstoque}
                                    permitir_edicao={config_integracao.permitir_produtos}
                                    permitir_visual={podeEditarProduto}
                                    tabelasBloqueadas={!permissoesPlano["TABELAS_DE_PRECOS"]?.permitido}
                                    onSetNivelTipo={(ordem, tipo) => variacoesV2.setNivelTipo(ordem, tipo)}
                                    onSetNivelValores={(ordem, valores) => variacoesV2.setNivelValores(ordem, valores)}
                                    onRemoveNivel={(ordem) => variacoesV2.removeNivel(ordem)}
                                    onSwapNiveis={() => variacoesV2.swapNiveis()}
                                    onUpdateVariacao={variacoesV2.updateVariacao}
                                    onDeleteVariacao={variacoesV2.deleteVariacao}
                                    onRestaurar={variacoesV2.restaurarVariacoes}
                                    onNovaListaDePreco={() => setModalListaDePreco(true)}
                                    onReplicar={variacoesV2.replicarCampo}
                                    onTiposUpdate={(tipos) => setTiposVariacao(tipos)}
                                    produto={{
                                        nome: produto.nome,
                                        referencia: produto.referencia,
                                        descricao: produto.descricao,
                                        fotos: produto.fotos,
                                    }}
                                    temDestaque={temDestaque}
                                    tagDestaque={
                                        tagsDestaque.find(t => t.id.toString() === tagSelecionada)?.nome_tag || ""
                                    }
                                    sugestoesVariacao={sugestoesVariacao}
                                    secundariaBloqueada={!permissoesPlano["ADICIONAR_VARIACAO_SECUNDARIA"]?.permitido}
                                    temVariacao={temVariacao}
                                    forceTab={forceTab}
                                    closeCategoriasSignal={closeCategoriasSignal}
                                    onCloseCategorias={() => setForceTab(null)}
                                    config_integracao={config_integracao}
                                    onCategoriasChange={fetchCategorias}
                                    permissoesPlano={permissoesPlano}
                                />
                            </SlidingBox>
                            </div>
                            <SlidingBox
                                active={midiasBox && activeTab == "midias"}
                                width="100%"
                                direction="right"
                            >
                                <MidiasBox
                                    ref={midiasBoxRef}
                                    adicionaFoto={(newImage) => {
                                        adicionaFoto(newImage);
                                    }}
                                    videosBloqueados={
                                        !permissoesPlano["LINK_DE_VIDEOS_ILIMITADOS_POR_PRODUTO"]?.permitido
                                    }
                                    adicionaVideo={(url_video) => {
                                        adicionaVideo(url_video);
                                    }}
                                    maxImages={empresa?.id_plano && [5, 9, 22].includes(empresa.id_plano) ? 1 : undefined}
                                />
                            </SlidingBox>
                        </div>

                        <FooterPaginas>
                            <FooterWrapper theme={theme}>
                                <div className="footer-content">
                                    <div className="inativar_produto fonteTexto">
                                        {produto.id != "0" && (
                                            <>
                                                {produto.id != "0" && produto.ativo == "1" ? (
                                                    podeExcluirProduto && !config_integracao.dropshipping_satelite ? (
                                                        <div className={"excluir_produto"}>
                                                            <div onClick={() => handleExcluirProduto()}>
                                                                Inativar
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={"excluir_produto"} style={{ opacity: 0.5, cursor: "not-allowed" }} title={config_integracao.dropshipping_satelite ? "Recurso indisponível em conta com Dropshipping ativo" : "Você não tem permissão para excluir produtos"}>
                                                            <div>Inativar</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <></>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    <div className="right-flex">
                                        <div className="duplicar">
                                            {produto.id !== "0" && duplicated !== "duplicado" && permissoesPlano && (
                                                (produtosBloqueados && produto.ativo == 0) || !podeEditarProduto || config_integracao.dropshipping_satelite ? (
                                                    <div
                                                        className="green blocked fonteTexto"
                                                        title={config_integracao.dropshipping_satelite ? "Recurso indisponível em conta com Dropshipping ativo" : !podeEditarProduto ? "Você não tem permissão para duplicar produtos" : "Você atingiu o limite de produtos para o seu plano."}>
                                                        Duplicar produto
                                                    </div>
                                                ) : (
                                                    <Link
                                                        to={`/painel/produtos/produto/${produto.id}/duplicado`}
                                                    >
                                                        <div className="green fonteTexto">Duplicar produto</div>
                                                    </Link>
                                                )
                                            )}
                                        </div>
                                        <div className="avancado">
                                            <Button
                                                className="button cinza fonteTexto"
                                                title={
                                                    activeTab == "avancado"
                                                        ? "Cancelar"
                                                        : "Configurações avançadas"
                                                }
                                                width="100%"
                                                onClick={(e) => {
                                                    activeTab == "avancado" ? Voltar() : Avancado();
                                                }}
                                            />
                                        </div>
                                        <div className="salvar fonteTexto">
                                            <Button
                                                type="submit"
                                                icon={
                                                    (produtosBloqueados && produto.id == "0") ||
                                                    (produto.ativo == 0 && produtosBloqueados) ? (
                                                        <LockedIcon
                                                            mensagem="Você atingiu o limite de produtos para o seu plano, faça o upgrade."
                                                            width="20px"
                                                            className="blocked"
                                                        />
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                iconRight={true}
                                                title={`Salvar e ${
                                                    produto.ativo == 0 ? "reativar" : "continuar"
                                                }`}
                                                onClick={(e) => {
                                                    if (
                                                        config_integracao.permitir_produtos ||
                                                        config_integracao.permitir_imagens ||
                                                        config_integracao.permitir_observacoes
                                                    ) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        Avancar();
                                                    }
                                                }}
                                                disabled={
                                                    (!config_integracao.permitir_produtos &&
                                                        !config_integracao.permitir_imagens &&
                                                        !config_integracao.permitir_observacoes) ||
                                                    (produtosBloqueados && produto.id == "0") ||
                                                    (produto.ativo == 0 && produtosBloqueados)
                                                }
                                                width="100%"
                                                loading={salvando}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </FooterWrapper>
                        </FooterPaginas>
                    </>
                )}
            </ViewContainer>
            <Modal
                isOpen={modalListaDePreco}
                setModal={setModalListaDePreco}
                children={
                    <ListaDePrecoBox
                        permitir_edicao={config_integracao.permitir_produtos}
                        permissoesPlano={permissoesPlano}
                        categorias={categorias}
                        setNovaListaDePreco={(newValue) => {
                            if (typeof newValue === "object" && newValue !== null) {
                                handleAddNewPriceList(newValue);
                            } else {
                                setNovaListaDePreco(newValue);
                            }
                        }}
                        setListaDePrecoBox={(newValue: boolean) => {
                            setModalListaDePreco(false);

                            // If needed, also fetch the latest price lists to ensure everything is up to date
                            if (newValue === false) {
                                (async () => {
                                    try {
                                        // Fetch the latest price lists
                                        const listasResult = await ApiListasDePreco.getListas(true);

                                        // Buscar preços atualizados do backend
                                        let backendPrices: Record<string, Record<string, string>> = {};
                                        if (id_produto != "0") {
                                            try {
                                                const produtoResponse = await produtoApi().getProduto(Number(id_produto));
                                                if (produtoResponse.variacoes_precos) {
                                                    produtoResponse.variacoes_precos.forEach((preco) => {
                                                        const key = String(preco.id_variacao);
                                                        if (!backendPrices[key]) backendPrices[key] = {};
                                                        backendPrices[key][String(preco.id_tabela)] = preco.preco;
                                                    });
                                                }
                                            } catch (e) {
                                                console.error("Erro ao buscar preços atualizados:", e);
                                            }
                                        }

                                        // Create deep copies to avoid reference issues
                                        const currentVariacoes = JSON.parse(
                                            JSON.stringify(produto.variacoes)
                                        );
                                        const currentVariacaoUnica = JSON.parse(
                                            JSON.stringify(variacaoUnica)
                                        );
                                        const currentListasDePreco = JSON.parse(
                                            JSON.stringify(listasDePreco)
                                        );

                                        // Create a map of the current price list order by ID
                                        const currentListaOrderMap = {};
                                        currentListasDePreco.forEach((lista, index) => {
                                            currentListaOrderMap[lista.id] = index;
                                        });

                                        // Preserve order of existing price lists and add new ones at the end
                                        const orderedListasResult = [...listasResult];
                                        orderedListasResult.sort((a, b) => {
                                            // If both lists existed before, use the original order
                                            if (
                                                currentListaOrderMap[a.id] !== undefined &&
                                                currentListaOrderMap[b.id] !== undefined
                                            ) {
                                                return (
                                                    currentListaOrderMap[a.id] -
                                                    currentListaOrderMap[b.id]
                                                );
                                            }
                                            // If only a existed before, it comes first
                                            if (currentListaOrderMap[a.id] !== undefined) {
                                                return -1;
                                            }
                                            // If only b existed before, it comes first
                                            if (currentListaOrderMap[b.id] !== undefined) {
                                                return 1;
                                            }
                                            // If both are new, maintain their order from the API
                                            return 0;
                                        });

                                        // Important: First, sync any changes from variacaoUnica to product variations if in single variation mode
                                        // This ensures we don't lose any changes made to the UI
                                        if (!temVariacao && currentVariacoes.length > 0) {
                                            // In single variation mode, we need to ensure the active variation has the same prices as variacaoUnica
                                            const activeVariation =
                                                currentVariacoes.find((v) => Number(v.ativo) === 1) ||
                                                currentVariacoes[0];

                                            // Map of all prices in variacaoUnica by table ID
                                            const variacaoUnicaPriceMap = {};
                                            currentVariacaoUnica.precos.forEach((preco) => {
                                                variacaoUnicaPriceMap[preco.id_tabela] = preco.preco;
                                            });

                                            // Update the active variation with prices from variacaoUnica
                                            if (activeVariation && activeVariation.precos) {
                                                activeVariation.precos.forEach((preco) => {
                                                    if (
                                                        variacaoUnicaPriceMap[preco.id_tabela] !== undefined
                                                    ) {
                                                        preco.preco =
                                                            variacaoUnicaPriceMap[preco.id_tabela];
                                                    }
                                                });
                                            }
                                        }

                                        // Create a persistent store of ALL prices across all variations and tables
                                        const allPricesByVariationAndTable = {};

                                        // First, collect all existing prices from current product variations
                                        currentVariacoes.forEach((variacao) => {
                                            if (!allPricesByVariationAndTable[variacao.id]) {
                                                allPricesByVariationAndTable[variacao.id] = {};
                                            }

                                            if (variacao.precos) {
                                                variacao.precos.forEach((preco) => {
                                                    // Store ALL prices regardless of table status
                                                    allPricesByVariationAndTable[variacao.id][
                                                        preco.id_tabela
                                                        ] = preco.preco;
                                                });
                                            }
                                        });

                                        // Sobrescrever com preços do backend (mais atualizados)
                                        Object.entries(backendPrices).forEach(([idVariacao, tabelas]) => {
                                            if (!allPricesByVariationAndTable[idVariacao]) {
                                                allPricesByVariationAndTable[idVariacao] = {};
                                            }
                                            Object.entries(tabelas).forEach(([idTabela, preco]) => {
                                                allPricesByVariationAndTable[idVariacao][idTabela] = preco;
                                            });
                                        });

                                        // Map existing variacaoUnica prices
                                        const allVariacaoUnicaPrices = {};
                                        if (currentVariacaoUnica.precos) {
                                            currentVariacaoUnica.precos.forEach((preco) => {
                                                allVariacaoUnicaPrices[preco.id_tabela] = preco.preco;
                                            });
                                        }

                                        // Sobrescrever variacaoUnica com preços do backend
                                        if (!temVariacao && currentVariacoes.length > 0) {
                                            const activeVar = currentVariacoes.find((v) => Number(v.ativo) === 1) || currentVariacoes[0];
                                            if (activeVar && backendPrices[String(activeVar.id)]) {
                                                Object.entries(backendPrices[String(activeVar.id)]).forEach(([idTabela, preco]) => {
                                                    allVariacaoUnicaPrices[idTabela] = preco;
                                                });
                                            }
                                        }

                                        // Set the updated price lists with preserved order
                                        setListasDePreco(orderedListasResult);

                                        // Update variations with new price lists while preserving ALL existing prices
                                        currentVariacoes.forEach((variacao) => {
                                            // Reset the precos array and rebuild it with updated price lists
                                            variacao.precos = orderedListasResult.map((tabela) => {
                                                // Check if we have an existing price in our complete price history
                                                const existingPrice =
                                                    allPricesByVariationAndTable[variacao.id] &&
                                                    allPricesByVariationAndTable[variacao.id][tabela.id];

                                                const finalPrice =
                                                    existingPrice !== undefined ? existingPrice : "0";

                                                return {
                                                    id: "0",
                                                    id_variacao: variacao.id,
                                                    id_tabela: tabela.id,
                                                    preco: finalPrice,
                                                };
                                            });
                                        });

                                        // Update the product with the updated variations
                                        setProduto({
                                            ...produto,
                                            variacoes: currentVariacoes,
                                        });

                                        // Update V2 variations with new price lists
                                        if (temVariacao && variacoesV2.niveisVariacao.length > 0) {
                                            variacoesV2.setVariacoes((prevV2) =>
                                                prevV2.map((v) => {
                                                    const existingPrices: Record<string, any> = {};
                                                    v.precos.forEach((p) => {
                                                        existingPrices[p.id_tabela] = p.preco;
                                                    });
                                                    // Also check backend prices
                                                    if (allPricesByVariationAndTable[v.id]) {
                                                        Object.entries(allPricesByVariationAndTable[v.id]).forEach(([idTabela, preco]) => {
                                                            if (existingPrices[idTabela] === undefined) {
                                                                existingPrices[idTabela] = preco;
                                                            }
                                                        });
                                                    }
                                                    return {
                                                        ...v,
                                                        precos: orderedListasResult.map((tabela) => ({
                                                            id: "0",
                                                            id_variacao: v.id,
                                                            id_tabela: tabela.id,
                                                            preco: existingPrices[tabela.id] !== undefined ? existingPrices[tabela.id] : "0",
                                                        })),
                                                    };
                                                })
                                            );
                                        }

                                        // Update variacaoUnica with new price lists while preserving ALL existing prices
                                        if (!temVariacao) {
                                            // In single variation mode, first copy all prices from the active variation
                                            const activeVariation =
                                                currentVariacoes.find((v) => Number(v.ativo) === 1) ||
                                                currentVariacoes[0];

                                            // Create a map of prices from the active variation
                                            const activeVariationPrices = {};
                                            if (activeVariation && activeVariation.precos) {
                                                activeVariation.precos.forEach((preco) => {
                                                    activeVariationPrices[preco.id_tabela] = preco.preco;
                                                });
                                            }

                                            const updatedPrecos = orderedListasResult.map(
                                                (tabela) => {
                                                    // First try to get price from variacaoUnica (UI state)
                                                    let existingPrice = allVariacaoUnicaPrices[tabela.id];

                                                    // If price doesn't exist in variacaoUnica, try to get it from the active variation
                                                    if (existingPrice === undefined) {
                                                        existingPrice = activeVariationPrices[tabela.id];
                                                    }

                                                    const finalPrice =
                                                        existingPrice !== undefined ? existingPrice : "0";

                                                    return {
                                                        id: "0",
                                                        id_variacao: currentVariacaoUnica.id,
                                                        id_tabela: tabela.id,
                                                        preco: finalPrice,
                                                    };
                                                }
                                            );

                                            setVariacaoUnica({
                                                ...currentVariacaoUnica,
                                                precos: updatedPrecos,
                                            });
                                        }
                                    } catch (error) {
                                        console.error("❌ Error updating price lists:", error);
                                    }
                                })();
                            }

                            setModalListaDePreco(newValue);
                        }}
                    />
                }
                width="100rem"
                maxWidth="99vw"
                align="center"
                backdrop="static"
                justify="center"
                padding="30px"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            />
            <Modal
                isOpen={modalGerarDescricaoIa}
                setModal={setModalGerarDescricaoIa}
                width="100rem"
                maxWidth="99vw"
                align="center"
                backdrop="static"
                justify="center"
                padding="24px 30px"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            >
                <ContainerDescricaoIa theme={theme}>
                    <>    
                        <div className="cabecalho-modal-descricao">
                            <div className="titulo fonteTitulo">Gerar Descrição com IA</div>
                            <div className="texto fonteTexto">
                                Gere descrições detalhadas com IA usando os tokens da sua conta. 
                                Adicione foto e dados do produto e receba textos completos que valorizam seus diferenciais.
                            </div>
                            <div className="quantidade-tokens">
                                <TokensIa className="tokens-ia"></TokensIa>
                                <p className="texto-quantidade-tokens fonteRotulos">
                                    {getInfoTokens()}
                                </p>
                            </div>
                        </div>
                        <div className="linha"></div>
                        <div className="campos-modal-descricao">
                            <div className="campo-tom-voz fonteTexto">
                                <Select
                                    label="Tom de voz"
                                    sizeLabel="medium"
                                    name="tomDeVoz"
                                    required={true}
                                    value={tomDeVoz}
                                    onChange={(newValue) => setTomDeVoz(newValue)}
                                    placeholder="Selecione um tom de voz"
                                    disabled={gerandoDescricaoIA}
                                    options={[
                                        { name: "Formal", value: "formal" },
                                        { name: "Descontraído", value: "descontraido" },
                                        { name: "Técnico", value: "tecnico" },
                                        { name: "Leve e acolhedor", value: "leve_acolhedor" }
                                    ]}
                                />
                            </div>

                            <div className="campo-midia">
                                <div className="titulo-secao fonteTexto">
                                    Mídia do produto
                                    <small className="texto-secao fonteRotulos">(opcional)</small>
                                </div>
                                {imagemProdutoIA ? (
                                    <div className="midia-carregada">
                                        <div className="miniatura-container">
                                            <div className="miniatura-imagem-wrapper">
                                                <img 
                                                    src={imagemProdutoIA} 
                                                    alt="Prévia da imagem" 
                                                    className="miniatura-imagem"
                                                    onClick={() => {
                                                        setImagemProdutoIA("");
                                                        setTimeout(() => {
                                                            imageUploadIARef.current?.triggerFileInput();
                                                        }, 100);
                                                    }}
                                                    onError={(e) => {
                                                        if (produto.fotos && produto.fotos.length > 0) {
                                                            const foto = produto.fotos[0];
                                                            const img = e.target as HTMLImageElement;
                                                            
                                                            if (foto.imagem_externa_2 && foto.imagem_externa_2 !== imagemProdutoIA) {
                                                                img.src = foto.imagem_externa_2;
                                                                return;
                                                            }
                                                            
                                                            if (foto.imagem_externa && foto.imagem_externa !== imagemProdutoIA) {
                                                                img.src = foto.imagem_externa;
                                                                return;
                                                            }
                                                            
                                                            if (foto.base64 && foto.base64 !== imagemProdutoIA) {
                                                                const base64Formatado = foto.base64.startsWith('data:image') 
                                                                    ? foto.base64 
                                                                    : `data:image/jpeg;base64,${foto.base64}`;
                                                                img.src = base64Formatado;
                                                                return;
                                                            }
                                                        }
                                                        
                                                        setImagemProdutoIA("");
                                                    }}
                                                />
                                                <button
                                                    className="botao-remover-imagem"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setImagemRemovidaManualmente(true);
                                                        setImagemProdutoIA("");
                                                    }}
                                                    title="Remover imagem"
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <ImageUploadProduto
                                        ref={imageUploadIARef}
                                        value={imagemProdutoIA}
                                        onChange={(newImage) => {
                                            setImagemProdutoIA(newImage.base64);
                                            setImagemRemovidaManualmente(false); // Reset flag ao adicionar nova imagem
                                            adicionaFoto(newImage);
                                        }}
                                        aspectRatio={1}
                                        minHeight={32}
                                    />
                                )}
                            </div>

                            <div className="campo-nome">
                                <Input
                                    label="Nome do produto"
                                    type="text"
                                    name="nomeProdutoIA"
                                    value={nomeProdutoIA}
                                    onChange={(newValue) => setNomeProdutoIA(newValue)}
                                    placeholder="Use palavras-chave que definam o produto"
                                    maxLength={64}
                                    disabled={gerandoDescricaoIA}
                                    required={true}
                                />
                            </div>

                            <div className="campo-caracteristicas">
                                <Textarea
                                    label="Características e benefícios do produto"
                                    sizeLabel="medium"
                                    type="text"
                                    name="caracteristicasBeneficios"
                                    value={caracteristicasBeneficios}
                                    onChange={(newValue) => setCaracteristicasBeneficios(newValue)}
                                    placeholder="Exemplo: Acabamento brilhante, disponível em diversos tamanhos, modelo elegante e atemporal, coleção 2025"
                                    disabled={gerandoDescricaoIA}
                                />
                            </div>

                            <div className="campo-instrucoes">
                                <div className="titulo-secao fonteTexto">
                                    Instruções especiais
                                    <small className="texto-secao fonteRotulos">(opcional)</small>
                                </div>
                                <Input
                                    type="text"
                                    name="instrucoesEspeciais"
                                    value={instrucoesEspeciais}
                                    onChange={(newValue) => setInstrucoesEspeciais(newValue)}
                                    placeholder="Exemplo: Usar ou não emojis, em x parágrafos, frases curtas..."
                                    disabled={gerandoDescricaoIA}
                                />
                            </div>

                            <div className="secao-quantidade-palavras">
                                <div className="titulo-secao fonteTexto">
                                    Quantidade de caracteres
                                    <small className="texto-secao fonteRotulos">(opcional)</small>
                                </div>
                                <div className="campos-quantidade">
                                    <div className="campo-minimo fonteRotulos">
                                        <label className="label-campo-quantidade fonteRotulos">Mínimo</label>
                                        <Input 
                                            type="text"
                                            name="quantidadePalavrasMin"
                                            value={quantidadePalavrasMin}
                                            onChange={(newValue) => {
                                                if (/^\d*$/.test(newValue)) {
                                                    setQuantidadePalavrasMin(newValue);
                                                }
                                            }}
                                            placeholder="50"
                                            maxLength={4}
                                            disabled={gerandoDescricaoIA}
                                        />
                                    </div>
                                    <div className="campo-maximo fonteRotulos">
                                        <label className="label-campo-quantidade fonteRotulos">Máximo</label>
                                        <Input
                                            type="text"
                                            name="quantidadePalavrasMax"
                                            value={quantidadePalavrasMax}
                                            onChange={(newValue) => {
                                                if (/^\d*$/.test(newValue)) {
                                                    setQuantidadePalavrasMax(newValue);
                                                }
                                            }}
                                            placeholder="200"
                                            maxLength={4}
                                            disabled={gerandoDescricaoIA}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="botoes fonteTexto">
                            <div 
                                className={`cancelar ${gerandoDescricaoIA ? 'disabled' : ''}`}
                                onClick={() => {
                                    if (gerandoDescricaoIA) return;
                                    // Manter os campos preenchidos no cache para quando o usuário voltar
                                    setModalGerarDescricaoIa(false);
                                }}
                                style={{
                                    opacity: gerandoDescricaoIA ? 0.5 : 1,
                                    cursor: gerandoDescricaoIA ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Cancelar
                            </div>
                            <Button 
                                title={getTextoBotao()} 
                                onClick={() => {
                                    // Validação dos campos obrigatórios
                                    if (!tomDeVoz) {
                                        Swal.fire({
                                            title: "Erro!",
                                            text: "Selecione um tom de voz",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                        });
                                        return;
                                    }
                                    
                                    if (!nomeProdutoIA.trim()) {
                                        Swal.fire({
                                            title: "Erro!",
                                            text: "Digite o nome do produto",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                        });
                                        return;
                                    }
                                    
                                    if (!caracteristicasBeneficios.trim()) {
                                        Swal.fire({
                                            title: "Erro!",
                                            text: "Digite as características e benefícios do produto",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                        });
                                        return;
                                    }
                                    
                                    handleGerarDescricaoIA();
                                }}
                                disabled={isBotaoDesabilitado()}
                                loading={gerandoDescricaoIA}
                                className={`${isBotaoDesabilitado() && 'disabled'}`}
                            />
                        </div>
                    </>
                </ContainerDescricaoIa>        
            </Modal>
            <Modal
                isOpen={modalResultadoIA}
                setModal={setModalResultadoIA}
                width="100rem"
                maxWidth="99vw"
                align="center"
                backdrop="static"
                justify="center"
                padding="24px 30px"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            >
                <ContainerDescricaoIa theme={theme}>
                    <div className="cabecalho-modal-descricao">
                        <div className="titulo fonteTitulo">Gerar Descrição com IA</div>
                        <div className="texto fonteTexto">
                            Sugestão de nome e descrição gerada a partir das informações fornecidas. 
                            Você pode voltar e editar esses dados. Ao aplicar, será possível complementar as informações no cadastro do produto.
                        </div>
                        <div className="quantidade-tokens">
                            <TokensIa className="tokens-ia"></TokensIa>
                            <p className="texto-quantidade-tokens fonteRotulos">
                                {getInfoTokens()}
                            </p>
                        </div>
                    </div>
                    <div className="linha"></div>
                    <div className="campos-modal-descricao">
                        <span className="tokens-usados fonteRotulos">
                            {tokensUtilizados ? 
                                `Utilizou ${tokensUtilizados.total_tokens.toLocaleString()} tokens para gerar essa descrição.` 
                                : 'Carregando informações de tokens...'}
                        </span>
                        <div className="campo-nome">
                            <Input
                                label="Nome do produto"
                                type="text"
                                name="nomeProdutoIA"
                                disabled={true}
                                value={resultadoNomeIA}
                                onChange={(newValue) => setResultadoNomeIA(newValue)}
                                placeholder="Use palavras-chave que definam o produto"
                                maxLength={64}
                                required={true}
                            />
                        </div>

                        <div className="campo-caracteristicas">
                            <Textarea
                                label="Descrição"
                                sizeLabel="medium"
                                disabled={true}
                                type="text"
                                name="caracteristicasBeneficios"
                                value={resultadoDescricaoIA}
                                onChange={(newValue) => setResultadoDescricaoIA(newValue)}
                                placeholder="Exemplo: Acabamento brilhante, disponível em diversos tamanhos, modelo elegante e atemporal, coleção 2025"
                            />
                        </div>
                    </div>

                    <div className="botoes fonteTexto">
                        <div 
                            className="cancelar"
                            onClick={() => {
                                setModalResultadoIA(false);
                                setModalGerarDescricaoIa(true);
                            }}
                        >
                            Voltar
                        </div>
                        <Button 
                            title="Aplicar" 
                            onClick={() => {
                                setProduto(prevProduto => {
                                    const novoProduto = {
                                        ...prevProduto,
                                        descricao: resultadoDescricaoIA,
                                        nome: resultadoNomeIA,
                                    };
                                    return novoProduto;
                                });
                                // Manter os campos preenchidos para a sessão e cache
                                setModalResultadoIA(false);
                            }}
                        />
                    </div>
                </ContainerDescricaoIa>
            </Modal>
            <Modal
                isOpen={modalMelhorarFotoIa}
                setModal={setModalMelhorarFotoIa}
                width="100rem"
                maxWidth="99vw"
                align="center"
                backdrop="static"
                justify="center"
                padding="24px 30px"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            >
                <ContainerDescricaoIa theme={theme}>
                    <div className="cabecalho-modal-descricao">
                        <div className="titulo fonteTitulo">Melhorar foto com IA</div>
                        {melhorandoImagemIA ? (
                            <div className="texto fonteTexto" style={{ padding: "3rem 0" }}>
                                <span className="gerando">Melhorando sua foto...</span><br/>
                                Isso pode levar alguns segundos
                            </div>
                        ) : (
                            <div className="texto fonteTexto">
                                Melhore suas fotografias com a IA do Conecta Venda, utilizando os tokens da sua conta. Importante: a IA não recria seu produto, apenas aprimora a fotografia como um todo. Fotografias que já apresentam boa qualidade e uma boa apresentação do produto podem não sofrer alterações significativas.
                            </div>
                        )}
                        {!melhorandoImagemIA && (
                            <div className="quantidade-tokens">
                                <TokensIa className="tokens-ia"></TokensIa>
                                <p className="texto-quantidade-tokens fonteRotulos">
                                    {getInfoTokens()}
                                </p>
                            </div>
                        )}
                    </div>
                    <div className="botoes fonteTexto">
                        <div
                            className="cancelar"
                            onClick={() => { if (melhorandoImagemIA) return; setModalMelhorarFotoIa(false); }}
                            style={{ opacity: melhorandoImagemIA ? 0.5 : 1, cursor: melhorandoImagemIA ? "not-allowed" : "pointer" }}
                        >
                            Cancelar
                        </div>
                        <Button
                            title={melhorandoImagemIA ? "Melhorando..." : "Melhorar foto"}
                            onClick={handleMelhorarFotoIA}
                            disabled={melhorandoImagemIA}
                            loading={melhorandoImagemIA}
                        />
                    </div>
                </ContainerDescricaoIa>
            </Modal>
            <Modal
                isOpen={modalResultadoFotoIa}
                setModal={setModalResultadoFotoIa}
                width="100rem"
                maxWidth="99vw"
                align="center"
                backdrop="static"
                justify="center"
                padding="24px 30px"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            >
                <ContainerDescricaoIa theme={theme}>
                    <div className="cabecalho-modal-descricao">
                        <div className="titulo fonteTitulo">Melhorar foto com IA</div>
                        <div className="texto fonteTexto">
                            Sugestão de melhoria de foto, gerada a partir da foto original compartilhada. Você pode cancelar a ação ou aplicar a melhoria. Importante: fotografias que já apresentam boa qualidade e uma boa apresentação do produto podem não sofrer alterações significativas.
                        </div>
                        <div className="quantidade-tokens">
                            <TokensIa className="tokens-ia"></TokensIa>
                            <p className="texto-quantidade-tokens fonteRotulos">
                                {getInfoTokens()}
                            </p>
                        </div>
                    </div>
                    <div className="linha"></div>
                    <div className="campos-modal-descricao">
                        <span className="tokens-usados fonteRotulos">
                            {tokensUsadosImagemIA
                                ? `Utilizou ${tokensUsadosImagemIA.toLocaleString()} tokens para melhorar essa foto.`
                                : ""}
                        </span>
                        <div className="imagem-resultado-ia">
                            <img src={resultadoImagemIA} alt="Imagem melhorada" />
                        </div>
                    </div>
                    <div className="botoes fonteTexto">
                        <div className="cancelar" onClick={() => setModalResultadoFotoIa(false)}>
                            Cancelar
                        </div>
                        <div style={{ display: "flex", gap: "1rem" }}>
                            <Button title="Baixar" onClick={() => baixarImagemMelhorada(resultadoImagemIA)} />
                            <Button title="Aplicar" onClick={aplicarImagemMelhorada} />
                        </div>
                    </div>
                </ContainerDescricaoIa>
            </Modal>
            <Modal
                isOpen={modalAtualizando}
                setModal={() => modalAtualizando}
                children={<ModalSucesso message={mensagemModal} type={stateModal}/>}
                width="80rem"
                maxWidth="99vw"
                align="center"
                justify="center"
                animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            />

            {/* Modal de Tags de Destaque */}
            <ModalTagsDestaque
                isOpen={modalTagsOpen}
                setModal={setModalTagsOpen}
                onSave={async (tags) => {
                    setTagsDestaque(tags);
                    // Recarregar tags após salvar
                    try {
                        const tagsResult = await tagsApi().getTags();
                        setTagsDestaque(tagsResult);
                    } catch (error) {
                        console.error("Erro ao recarregar tags:", error);
                    }
                }}
            />
        </>
    );
}

export default Produto;
